import { CImage, CTabSelector } from "../../src/components/atoms";
import { Constants, Images, Values } from "../../src/config";
import { FestivalDao, VenueDao } from "../../src/DAO";
import {
  LocationModal,
  SingleSelectModal,
} from "../../src/components/molecules";
import React, { useEffect, useRef, useState } from "react";
import { generateURLSlug, nFormatter } from "../../helpers";

import CardItem from "../../src/components/molecules/CardList/components/CardItem";
import ExploreSearch from "../../src/modules/explore_search/index";
import FilterScreen from "../../src/modules/filter";
import FilterView from "../../src/modules/explore_search/components/FilterView";
import Footer from "../../components_web/Footer";
import HeaderSearch from "../../components_web/HeaderSearch";
import Link from "next/link";
import NavigationSearchView from "../../src/modules/explore_search/components/NavigationSearchView";
import { NextSeo } from "next-seo";
import { capitalizeFirstLetter } from "../../src/helpers/formatHelpers";
import dynamic from "next/dynamic";
import { getClass } from "../../src/helpers/formatHelpers";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import { useRouter } from "next/router";
import { useSwipeable } from "react-swipeable";
import { useTranslation } from "react-i18next";

const DynamicMap = dynamic(() => import("../../src/components/molecules/Map"), {
  ssr: false,
});

export async function getServerSideProps(context) {
  try {
    const { params, query } = context;
    const dataCategoryProps =
      params.category === "artists" &&
      process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
        ? Constants.categoryType.CATEGORY_ARTIST
        : params.category === "festivals" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
        ? Constants.categoryType.CATEGORY_FESTIVAL
        : params.category === "venues" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
        ? Constants.categoryType.CATEGORY_VENUE
        : params.category === "events" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
        ? Constants.categoryType.CATEGORY_EVENT
        : params.category === "rooftops" &&
          process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
        ? Constants.categoryType.CATEGORY_ROOFTOP
        : params.category === "spas" &&
          process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
        ? Constants.categoryType.CATEGORY_SPA
        : params.category === "beach-clubs" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
        ? Constants.categoryType.CATEGORY_VENUE_BEACHFUL
        : params.category === "companies" &&
          process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
        ? Constants.categoryType.CATEGORY_PREFAB_COMPANY
        : params.category === "homes" &&
          process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
        ? Constants.categoryType.CATEGORY_PREFAB_HOMES
        : params.category === "zoos" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
        ? Constants.categoryType.CATEGORY_ZOO
        : params.category === "animals" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
        ? Constants.categoryType.CATEGORY_ANIMAL
        : params.category === "parks" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
        ? Constants.categoryType.CATEGORY_PARKFUL
        : params.category === "casinos" &&
          process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
        ? Constants.categoryType.CATEGORY_CASINO
        : params.category === "castles" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
        ? Constants.categoryType.CATEGORY_CASTLE
        : params.category === "resorts" &&
          process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
        ? Constants.categoryType.CATEGORY_RESORT
        : params.category === "aparthotels" &&
          process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
        ? Constants.categoryType.CATEGORY_APARTHOTEL
        : params.category === "bars" &&
          process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
        ? Constants.categoryType.CATEGORY_VENUE_COCKTAIL
        : null;
    const pageProps = query.page || 1;

    if (
      params.category == "spa" &&
      process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
    ) {
      return {
        redirect: {
          permanent: true,
          destination: "/explore/spas",
        },
      };
    } else if (
      params.category == "venues-beachful" &&
      process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
    ) {
      return {
        redirect: {
          permanent: true,
          destination: "/explore/beach-clubs",
        },
      };
    }

    if (!dataCategoryProps) {
      return {
        redirect: {
          permanent: false,
          destination: "/",
        },
      };
    }

    const { festivalProps, countFestivalProps } = await new Promise(
      (resolve, reject) => {
        if (dataCategoryProps === Constants.categoryType.CATEGORY_FESTIVAL) {
          FestivalDao.findWeb({
            pageIndex: pageProps - 1,
            pageSize: 24,
            sortType: Constants.sortByAction.SORT_BY_RECENT,
          })
            .then((result) =>
              resolve({
                festivalProps: result.data,
                countFestivalProps: result.totalCount,
              })
            )
            .catch((err) => reject(err));
        } else {
          resolve({
            festivalProps: [],
            countFestivalProps: 0,
          });
        }
      }
    );

    const { venueProps, countVenueProps } = await new Promise(
      (resolve, reject) => {
        if (
          dataCategoryProps !== Constants.categoryType.CATEGORY_FESTIVAL &&
          dataCategoryProps !== Constants.categoryType.CATEGORY_ARTIST &&
          dataCategoryProps !== Constants.categoryType.CATEGORY_EVENT
        ) {
          VenueDao.find({
            pageIndex: pageProps - 1,
            pageSize: 36,
            sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
            categoryType: dataCategoryProps,
            venueStatus: [
              Constants.venueStatus.FE_STAT_OPEN,
              Constants.venueStatus.FE_STAT_CLOSE,
              Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
            ],
          })
            .then((result) =>
              resolve({
                venueProps: result.data,
                countVenueProps: result.totalCount,
              })
            )
            .catch((err) => reject(err));
        } else {
          resolve({
            venueProps: [],
            countVenueProps: 0,
          });
        }
      }
    );

    return {
      props: {
        dataCategoryProps,
        pageProps,
        festivalProps,
        countFestivalProps,
        venueProps,
        countVenueProps,
      },
    };
  } catch (err) {
    console.error("err", err);
    return {
      notFound: true,
    };
  }
}

const Festivals = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { category, search, page, view } = router.query;
  const handlers = useSwipeable({
    onSwipedLeft: (eventData) => {
      if (category === Constants.categoryType.CATEGORY_VENUE) {
        const newIndex = itemsVenue?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsVenue.length) {
          setMapFocused(itemsVenue?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_ROOFTOP) {
        const newIndex =
          itemsRooftop?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsRooftop.length) {
          setMapFocused(
            itemsRooftop?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_SPA) {
        const newIndex = itemsSpa?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsSpa.length) {
          setMapFocused(itemsSpa?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL) {
        const newIndex =
          itemsVenueBeachful?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsVenueBeachful.length) {
          setMapFocused(
            itemsVenueBeachful?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PREFAB_COMPANY) {
        const newIndex =
          itemsPrefabCompany?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsPrefabCompany.length) {
          setMapFocused(
            itemsPrefabCompany?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PREFAB_HOMES) {
        const newIndex =
          itemsPrefabHome?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsPrefabHome.length) {
          setMapFocused(
            itemsPrefabHome?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_ZOO) {
        const newIndex = itemsZoo?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsZoo.length) {
          setMapFocused(itemsZoo?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_ANIMAL) {
        const newIndex = itemsAnimal?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsAnimal.length) {
          setMapFocused(
            itemsAnimal?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PARKFUL) {
        const newIndex =
          itemsParkful?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsParkful.length) {
          setMapFocused(
            itemsParkful?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_CASINO) {
        const newIndex = itemsCasino?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsCasino.length) {
          setMapFocused(
            itemsCasino?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_CASTLE) {
        const newIndex = itemsCastle?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsCastle.length) {
          setMapFocused(
            itemsCastle?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_RESORT) {
        const newIndex = itemsResort?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsResort.length) {
          setMapFocused(
            itemsResort?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_APARTHOTEL) {
        const newIndex =
          itemsAparthotel?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsAparthotel.length) {
          setMapFocused(
            itemsAparthotel?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL) {
        const newIndex =
          itemsVenueCocktail?.findIndex((i) => i.id === mapFocused) + 1;
        if (newIndex < itemsVenueCocktail.length) {
          setMapFocused(
            itemsVenueCocktail?.find((i, index) => index === newIndex)?.id
          );
        }
      }
    },
    onSwipedRight: (eventData) => {
      if (category === Constants.categoryType.CATEGORY_VENUE) {
        const newIndex = itemsVenue?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(itemsVenue?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_ROOFTOP) {
        const newIndex =
          itemsRooftop?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsRooftop?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_SPA) {
        const newIndex = itemsSpa?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(itemsSpa?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL) {
        const newIndex =
          itemsVenueBeachful?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsVenueBeachful?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PREFAB_COMPANY) {
        const newIndex =
          itemsPrefabCompany?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsPrefabCompany?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PREFAB_HOMES) {
        const newIndex =
          itemsPrefabHome?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsPrefabHome?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_ZOO) {
        const newIndex = itemsZoo?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(itemsZoo?.find((i, index) => index === newIndex)?.id);
        }
      } else if (category === Constants.categoryType.CATEGORY_ANIMAL) {
        const newIndex = itemsAnimal?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsAnimal?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_PARKFUL) {
        const newIndex =
          itemsParkful?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsParkful?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_CASINO) {
        const newIndex = itemsCasino?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsCasino?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_CASTLE) {
        const newIndex = itemsCastle?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsCastle?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_RESORT) {
        const newIndex = itemsResort?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsResort?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_APARTHOTEL) {
        const newIndex =
          itemsAparthotel?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsAparthotel?.find((i, index) => index === newIndex)?.id
          );
        }
      } else if (category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL) {
        const newIndex =
          itemsVenueCocktail?.findIndex((i) => i.id === mapFocused) - 1;
        if (newIndex >= 0) {
          setMapFocused(
            itemsVenueCocktail?.find((i, index) => index === newIndex)?.id
          );
        }
      }
    },
  });

  const locationModal = useRef(null);
  const sortMenuModal = useRef(null);
  const sortMenu = [
    {
      id: Constants.sortByAction.SORT_BY_RECOMMENDED,
      label: t("key_sort_option_recommended"),
      isHide:
        category !== "festivals" &&
        category !== "venues" &&
        category !== "rooftops" &&
        category !== "spas" &&
        category !== "beach-clubs" &&
        category !== "companies" &&
        category !== "homes" &&
        category !== "parks" &&
        category !== "casinos" &&
        category !== "castles" &&
        category !== "resorts" &&
        category !== "aparthotels" &&
        category !== "bars",
    },
    {
      id: Constants.sortByAction.SORT_BY_POPULARITY,
      label: t("key_sort_option_popularity"),
      isHide:
        category === "festivals" ||
        category === "venues" ||
        category === "rooftops" ||
        category === "spas" ||
        category === "beach-clubs" ||
        category === "companies" ||
        category === "homes" ||
        category === "parks" ||
        category === "casinos" ||
        category === "castles" ||
        category === "resorts" ||
        category === "aparthotels" ||
        category === "bars",
    },
    {
      id: Constants.sortByAction.SORT_BY_RECENT,
      label: t("key_sort_option_date"),
      isHide: category !== "festivals" && category !== "events",
    },
    // {
    //   id: Constants.sortByAction.SORT_BY_TRENDING,
    //   label: t("key_sort_option_trending"),
    //   isHide: false,
    // },
    {
      id: Constants.sortByAction.SORT_BY_PRICE_LOW,
      label: t("key_sort_option_price"),
      suffix: t("key_sort_option_low_high"),
      isHide: category !== "festivals" && category !== "events",
    },
    {
      id: Constants.sortByAction.SORT_BY_PRICE_HIGH,
      label: t("key_sort_option_price"),
      suffix: t("key_sort_option_high_low"),
      isHide: category !== "festivals" && category !== "events",
    },
    // {
    //   id: Constants.sortByAction.SORT_BY_RATING_LOW,
    //   label: t("key_sort_option_rating"),
    //   suffix: t("key_sort_option_low_high"),
    //   isHide: false,
    // },
    // {
    //   id: Constants.sortByAction.SORT_BY_RATING_HIGH,
    //   label: t("key_sort_option_rating"),
    //   suffix: t("key_sort_option_high_low"),
    //   isHide: false,
    // },
    {
      id: Constants.sortByAction.SORT_BY_NAMEATOZ,
      label: t("key_sort_option_name"),
      suffix: t("key_sort_option_a_z"),
      isHide: false,
    },
    {
      id: Constants.sortByAction.SORT_BY_NAMEZTOA,
      label: t("key_sort_option_name"),
      suffix: t("key_sort_option_z_a"),
      isHide: false,
    },
  ];

  const [showFilter, setShowFilter] = useState(false);
  const [keyword, setKeyword] = useState(search || "");
  const [dataCategory, setDataCategory] = useState(
    props.dataCategoryProps || null
  );
  const [locationSelected, setLocationSelected] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [sortList, setSortList] = useState([]);

  // Festival
  const [
    filterCriteriaListOriginalFestival,
    setFilterCriteriaListOriginalFestival,
  ] = useState(null);
  const [
    filterCriteriaListSelectedFestival,
    setFilterCriteriaListSelectedFestival,
  ] = useState(null);
  const [filterTabSelectedFestival, setFilterTabSelectedFestival] =
    useState(null);

  // Event
  const [filterCriteriaListOriginalEvent, setFilterCriteriaListOriginalEvent] =
    useState(null);
  const [filterCriteriaListSelectedEvent, setFilterCriteriaListSelectedEvent] =
    useState(null);
  const [filterTabSelectedEvent, setFilterTabSelectedEvent] = useState(null);

  // Artist
  const [
    filterCriteriaListOriginalArtist,
    setFilterCriteriaListOriginalArtist,
  ] = useState(null);
  const [
    filterCriteriaListSelectedArtist,
    setFilterCriteriaListSelectedArtist,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedArtist, setFilterTabSelectedArtist] = useState(null);

  // Venue
  const [filterCriteriaListOriginalVenue, setFilterCriteriaListOriginalVenue] =
    useState(null);
  const [filterCriteriaListSelectedVenue, setFilterCriteriaListSelectedVenue] =
    useState(null);
  useState(null);
  const [filterTabSelectedVenue, setFilterTabSelectedVenue] = useState(null);

  // Rooftop
  const [
    filterCriteriaListOriginalRooftop,
    setFilterCriteriaListOriginalRooftop,
  ] = useState(null);
  const [
    filterCriteriaListSelectedRooftop,
    setFilterCriteriaListSelectedRooftop,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedRooftop, setFilterTabSelectedRooftop] =
    useState(null);

  // Spa
  const [filterCriteriaListOriginalSpa, setFilterCriteriaListOriginalSpa] =
    useState(null);
  const [filterCriteriaListSelectedSpa, setFilterCriteriaListSelectedSpa] =
    useState(null);
  useState(null);
  const [filterTabSelectedSpa, setFilterTabSelectedSpa] = useState(null);

  // VenueBeachful
  const [
    filterCriteriaListOriginalVenueBeachful,
    setFilterCriteriaListOriginalVenueBeachful,
  ] = useState(null);
  const [
    filterCriteriaListSelectedVenueBeachful,
    setFilterCriteriaListSelectedVenueBeachful,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedVenueBeachful, setFilterTabSelectedVenueBeachful] =
    useState(null);

  // PrefabCompany
  const [
    filterCriteriaListOriginalPrefabCompany,
    setFilterCriteriaListOriginalPrefabCompany,
  ] = useState(null);
  const [
    filterCriteriaListSelectedPrefabCompany,
    setFilterCriteriaListSelectedPrefabCompany,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedPrefabCompany, setFilterTabSelectedPrefabCompany] =
    useState(null);

  // PrefabHome
  const [
    filterCriteriaListOriginalPrefabHome,
    setFilterCriteriaListOriginalPrefabHome,
  ] = useState(null);
  const [
    filterCriteriaListSelectedPrefabHome,
    setFilterCriteriaListSelectedPrefabHome,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedPrefabHome, setFilterTabSelectedPrefabHome] =
    useState(null);

  // Zoo
  const [filterCriteriaListOriginalZoo, setFilterCriteriaListOriginalZoo] =
    useState(null);
  const [filterCriteriaListSelectedZoo, setFilterCriteriaListSelectedZoo] =
    useState(null);
  useState(null);
  const [filterTabSelectedZoo, setFilterTabSelectedZoo] = useState(null);

  // Animal
  const [
    filterCriteriaListOriginalAnimal,
    setFilterCriteriaListOriginalAnimal,
  ] = useState(null);
  const [
    filterCriteriaListSelectedAnimal,
    setFilterCriteriaListSelectedAnimal,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedAnimal, setFilterTabSelectedAnimal] = useState(null);

  // Parkful
  const [
    filterCriteriaListOriginalParkful,
    setFilterCriteriaListOriginalParkful,
  ] = useState(null);
  const [
    filterCriteriaListSelectedParkful,
    setFilterCriteriaListSelectedParkful,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedParkful, setFilterTabSelectedParkful] =
    useState(null);

  // Casino
  const [
    filterCriteriaListOriginalCasino,
    setFilterCriteriaListOriginalCasino,
  ] = useState(null);
  const [
    filterCriteriaListSelectedCasino,
    setFilterCriteriaListSelectedCasino,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedCasino, setFilterTabSelectedCasino] = useState(null);

  // Castle
  const [
    filterCriteriaListOriginalCastle,
    setFilterCriteriaListOriginalCastle,
  ] = useState(null);
  const [
    filterCriteriaListSelectedCastle,
    setFilterCriteriaListSelectedCastle,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedCastle, setFilterTabSelectedCastle] = useState(null);

  // Resort
  const [
    filterCriteriaListOriginalResort,
    setFilterCriteriaListOriginalResort,
  ] = useState(null);
  const [
    filterCriteriaListSelectedResort,
    setFilterCriteriaListSelectedResort,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedResort, setFilterTabSelectedResort] = useState(null);

  // Aparthotel
  const [
    filterCriteriaListOriginalAparthotel,
    setFilterCriteriaListOriginalAparthotel,
  ] = useState(null);
  const [
    filterCriteriaListSelectedAparthotel,
    setFilterCriteriaListSelectedAparthotel,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedAparthotel, setFilterTabSelectedAparthotel] =
    useState(null);

  // Venue Cocktail
  const [
    filterCriteriaListOriginalVenueCocktail,
    setFilterCriteriaListOriginalVenueCocktail,
  ] = useState(null);
  const [
    filterCriteriaListSelectedVenueCocktail,
    setFilterCriteriaListSelectedVenueCocktail,
  ] = useState(null);
  useState(null);
  const [filterTabSelectedVenueCocktail, setFilterTabSelectedVenueCocktail] =
    useState(null);

  const [countFestival, setCountFestival] = useState(
    props.countFestivalProps || 0
  );
  const [countEvent, setCountEvent] = useState(0);
  const [countArtist, setCountArtist] = useState(0);
  const [countVenue, setCountVenue] = useState(props.countVenueProps || 0);
  const [countRooftop, setCountRooftop] = useState(props.countVenueProps || 0);
  const [countSpa, setCountSpa] = useState(props.countVenueProps || 0);
  const [countVenueBeachful, setCountVenueBeachful] = useState(
    props.countVenueProps || 0
  );
  const [countPrefabCompany, setCountPrefabCompany] = useState(
    props.countVenueProps || 0
  );
  const [countPrefabHome, setCountPrefabHome] = useState(
    props.countVenueProps || 0
  );
  const [countZoo, setCountZoo] = useState(props.countVenueProps || 0);
  const [countAnimal, setCountAnimal] = useState(props.countVenueProps || 0);
  const [countParkful, setCountParkful] = useState(props.countVenueProps || 0);
  const [countCasino, setCountCasino] = useState(props.countVenueProps || 0);
  const [countCastle, setCountCastle] = useState(props.countVenueProps || 0);
  const [countResort, setCountResort] = useState(props.countVenueProps || 0);
  const [countAparthotel, setCountAparthotel] = useState(
    props.countVenueProps || 0
  );
  const [countVenueCocktail, setCountVenueCocktail] = useState(
    props.countVenueProps || 0
  );

  const {
    buttonProps: buttonPropsTypeMode,
    itemProps: itemPropsTypeMode,
    isOpen: isOpenTypeMode,
    setIsOpen: setIsOpenTypeMode,
  } = useDropdownMenu(1);

  const {
    buttonProps: buttonPropsMenuMore,
    itemProps: itemPropsMenuMore,
    isOpen: isOpenMenuMore,
    setIsOpen: setIsOpenMenuMore,
  } = useDropdownMenu(1);

  const [typeMode, setTypeMode] = useState(null);
  const [typeModeList, setTypeModeList] = useState([
    {
      title: "All",
      count: 0,
      value: null,
      onClick: () => {
        setTypeMode(null);
        setFilterTabSelectedFestival(null);
        setIsOpenTypeMode(false);
      },
    },
    {
      title: "Followed",
      count: 0,
      value: 1,
      onClick: () => {
        setTypeMode(1);
        setFilterTabSelectedFestival(1);
        setIsOpenTypeMode(false);
      },
    },
    // {
    //   title: "Related",
    //   count: 0,
    //   value: 2,
    //   onClick: () => {
    //     setFilterTabSelectedFestival(2);
    //     setTypeMode(2);
    //     setIsOpenTypeMode(false);
    //   },
    // },
    {
      title: "Other",
      count: 0,
      value: 3,
      onClick: () => {
        setTypeMode(3);
        setFilterTabSelectedFestival(3);
        setIsOpenTypeMode(false);
      },
    },
  ]);

  const {
    buttonProps: buttonPropsViewMode,
    itemProps: itemPropsViewMode,
    isOpen: isOpenViewMode,
    setIsOpen: setIsOpenViewMode,
  } = useDropdownMenu(1);
  const [viewMode, setViewMode] = useState(
    view || Constants.viewType.VIEW_TYPE_GRID
  );
  const [itemsVenue, setItemsVenue] = useState(props.venueProps || []);
  const [itemsRooftop, setItemsRooftop] = useState(props.venueProps || []);
  const [itemsSpa, setItemsSpa] = useState(props.venueProps || []);
  const [itemsVenueBeachful, setItemsVenueBeachful] = useState(
    props.venueProps || []
  );
  const [itemsPrefabCompany, setItemsPrefabCompany] = useState(
    props.venueProps || []
  );
  const [itemsPrefabHome, setItemsPrefabHome] = useState(
    props.venueProps || []
  );
  const [itemsZoo, setItemsZoo] = useState(props.venueProps || []);
  const [itemsAnimal, setItemsAnimal] = useState(props.venueProps || []);
  const [itemsParkful, setItemsParkful] = useState(props.venueProps || []);
  const [itemsCasino, setItemsCasino] = useState(props.venueProps || []);
  const [itemsCastle, setItemsCastle] = useState(props.venueProps || []);
  const [itemsResort, setItemsResort] = useState(props.venueProps || []);
  const [itemsAparthotel, setItemsAparthotel] = useState(
    props.venueProps || []
  );
  const [itemsVenueCocktail, setItemsVenueCocktail] = useState(
    props.venueProps || []
  );
  const [itemsFestival, setItemsFestival] = useState(props.festivalProps || []);
  const [itemsEvent, setItemsEvent] = useState([]);
  const [viewModeList, setViewModeList] = useState([]);
  const [mapFocused, setMapFocused] = useState(null);

  const {
    buttonProps: buttonPropsSort,
    itemProps: itemPropsSort,
    isOpen: isOpenSort,
    setIsOpen: setIsOpenSort,
  } = useDropdownMenu(1);

  const categoryMobile = [
    {
      count: countVenue,
      id: Constants.categoryType.CATEGORY_VENUE,
      slug: "venues",
      title: "Venues",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Venues"
      ),
    },
    {
      count: countRooftop,
      id: Constants.categoryType.CATEGORY_ROOFTOP,
      slug: "rooftops",
      title: "Rooftops",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Rooftops"
      ),
    },
    {
      count: countSpa,
      id: Constants.categoryType.CATEGORY_SPA,
      slug: "spas",
      title: "Spas",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Spas"
      ),
    },
    {
      count: countVenueBeachful,
      id: Constants.categoryType.CATEGORY_VENUE_BEACHFUL,
      slug: "beach-clubs",
      title: "Beach Clubs",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Venue Beachful"
      ),
    },
    {
      count: countPrefabHome,
      id: Constants.categoryType.CATEGORY_PREFAB_HOMES,
      slug: "homes",
      title: "Homes",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Prefab Home"
      ),
    },
    {
      count: countPrefabCompany,
      id: Constants.categoryType.CATEGORY_PREFAB_COMPANY,
      slug: "companies",
      title: "Companies",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Prefab Company"
      ),
    },
    {
      count: countZoo,
      id: Constants.categoryType.CATEGORY_ZOO,
      slug: "zoos",
      title: "Zoos",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Zoos"
      ),
    },
    {
      count: countAnimal,
      id: Constants.categoryType.CATEGORY_ANIMAL,
      slug: "animals",
      title: "Animals",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Animals"
      ),
    },
    {
      count: countParkful,
      id: Constants.categoryType.CATEGORY_PARKFUL,
      slug: "parks",
      title: "Parks",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Parks"
      ),
    },
    {
      count: countCasino,
      id: Constants.categoryType.CATEGORY_CASINO,
      slug: "casinos",
      title: "Casinos",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Casinos"
      ),
    },
    {
      count: countCastle,
      id: Constants.categoryType.CATEGORY_CASTLE,
      slug: "castles",
      title: "Castles",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Castles"
      ),
    },
    {
      count: countResort,
      id: Constants.categoryType.CATEGORY_RESORT,
      slug: "resorts",
      title: "Resorts",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Resorts"
      ),
    },
    {
      count: countAparthotel,
      id: Constants.categoryType.CATEGORY_APARTHOTEL,
      slug: "aparthotels",
      title: "Aparthotels",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Aparthotels"
      ),
    },
    {
      count: countVenueCocktail,
      id: Constants.categoryType.CATEGORY_VENUE_COCKTAIL,
      slug: "bars",
      title: "Bars",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Venue Cocktail"
      ),
    },
    {
      count: countFestival,
      id: Constants.categoryType.CATEGORY_FESTIVAL,
      slug: "festivals",
      title: "Festivals",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Festivals"
      ),
    },
    {
      count: countEvent,
      id: Constants.categoryType.CATEGORY_EVENT,
      slug: "events",
      title: "Events",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Events"
      ),
    },
    {
      count: countArtist,
      id: Constants.categoryType.CATEGORY_ARTIST,
      slug: "artists",
      title: "Artists",
      isHide: !process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
        (i) => i === "Artists"
      ),
    },
  ];

  const getSortBy = () => {
    return (
      sortBy ||
      (dataCategory === Constants.categoryType.CATEGORY_FESTIVAL ||
      dataCategory === Constants.categoryType.CATEGORY_EVENT
        ? Constants.sortByAction.SORT_BY_RECENT
        : dataCategory === Constants.categoryType.CATEGORY_VENUE ||
          dataCategory === Constants.categoryType.CATEGORY_ROOFTOP ||
          dataCategory === Constants.categoryType.CATEGORY_SPA ||
          dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
          dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
          dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
          dataCategory === Constants.categoryType.CATEGORY_ZOO ||
          dataCategory === Constants.categoryType.CATEGORY_ANIMAL ||
          dataCategory === Constants.categoryType.CATEGORY_PARKFUL ||
          dataCategory === Constants.categoryType.CATEGORY_CASINO ||
          dataCategory === Constants.categoryType.CATEGORY_CASTLE ||
          dataCategory === Constants.categoryType.CATEGORY_RESORT ||
          dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL ||
          dataCategory === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
        ? Constants.sortByAction.SORT_BY_RECOMMENDED
        : Constants.sortByAction.SORT_BY_POPULARITY)
    );
  };

  // Set Sorting and View mode
  useEffect(() => {
    if (category === "festivals" || category === "events") {
      setSortBy(Constants.sortByAction.SORT_BY_RECENT);
      setSortList([
        {
          title: "Recommended",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_RECOMMENDED,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
            setIsOpenSort(false);
          },
        },
        {
          title: "Date",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_RECENT,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_RECENT);
            setIsOpenSort(false);
          },
        },
        // {
        //   title: "Trending",
        //   subtitle: null,
        //   value: Constants.sortByAction.SORT_BY_TRENDING,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Price",
          subtitle: "Low-High",
          value: Constants.sortByAction.SORT_BY_PRICE_LOW,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_PRICE_LOW);
            setIsOpenSort(false);
          },
        },
        {
          title: "Price",
          subtitle: "High-Low",
          value: Constants.sortByAction.SORT_BY_PRICE_HIGH,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_PRICE_HIGH);
            setIsOpenSort(false);
          },
        },
        // {
        //   title: "Rating",
        //   subtitle: "Low-High",
        //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
        //     setIsOpenSort(false);
        //   },
        // },
        // {
        //   title: "Rating",
        //   subtitle: "High-Low",
        //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Name",
          subtitle: "A-Z",
          value: Constants.sortByAction.SORT_BY_NAMEATOZ,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEATOZ);
            setIsOpenSort(false);
          },
        },
        {
          title: "Name",
          subtitle: "Z-A",
          value: Constants.sortByAction.SORT_BY_NAMEZTOA,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEZTOA);
            setIsOpenSort(false);
          },
        },
      ]);
      setViewModeList([
        {
          title: "Grid",
          value: Constants.viewType.VIEW_TYPE_GRID,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_GRID);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "grid" },
            });
          },
        },
        {
          title: "List",
          value: Constants.viewType.VIEW_TYPE_LIST,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_LIST);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "list" },
            });
          },
        },
        // {
        //   title: "Overview",
        //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
        //   onClick: () => {
        //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
        //     setIsOpenViewMode(false);
        //     router.push({
        //       query: { ...router.query, page: 1, view: "overview" },
        //     });
        //   },
        // },
        {
          title: "Map",
          value: Constants.viewType.VIEW_TYPE_MAP,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_MAP);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "map" },
            });
          },
        },
      ]);
      setViewMode(Constants.viewType.VIEW_TYPE_GRID);
    } else if (category === "artists") {
      setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
      setSortList([
        {
          title: "Popularity",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_POPULARITY,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
            setIsOpenSort(false);
          },
        },
        /*{
            title: "Trending",
            subtitle: null,
            value: Constants.sortByAction.SORT_BY_TRENDING,
            onClick: () => {
              setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
              setIsOpenSort(false);
            },
          },*/
        // {
        //   title: "Rating",
        //   subtitle: "Low-High",
        //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
        //     setIsOpenSort(false);
        //   },
        // },
        // {
        //   title: "Rating",
        //   subtitle: "High-Low",
        //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Name",
          subtitle: "A-Z",
          value: Constants.sortByAction.SORT_BY_NAMEATOZ,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEATOZ);
            setIsOpenSort(false);
          },
        },
        {
          title: "Name",
          subtitle: "Z-A",
          value: Constants.sortByAction.SORT_BY_NAMEZTOA,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEZTOA);
            setIsOpenSort(false);
          },
        },
      ]);
      setViewModeList([
        {
          title: "Grid",
          value: Constants.viewType.VIEW_TYPE_GRID,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_GRID);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "grid" },
            });
          },
        },
        {
          title: "List",
          value: Constants.viewType.VIEW_TYPE_LIST,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_LIST);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "list" },
            });
          },
        },
        // {
        //   title: "Overview",
        //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
        //   onClick: () => {
        //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
        //     setIsOpenViewMode(false);
        //     router.push({
        //       query: { ...router.query, page: 1, view: "overview" },
        //     });
        //   },
        // },
      ]);
      setViewMode(Constants.viewType.VIEW_TYPE_GRID);
    } else if (category === "venues") {
      setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([
        {
          title: "Recommended",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_RECOMMENDED,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
            setIsOpenSort(false);
          },
        },
        // {
        //   title: "Popularity",
        //   subtitle: null,
        //   value: Constants.sortByAction.SORT_BY_POPULARITY,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
        //     setIsOpenSort(false);
        //   },
        // },
        /*{
          title: "Trending",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_TRENDING,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
            setIsOpenSort(false);
          },
        },*/
        // {
        //   title: "Rating",
        //   subtitle: "Low-High",
        //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
        //     setIsOpenSort(false);
        //   },
        // },
        // {
        //   title: "Rating",
        //   subtitle: "High-Low",
        //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Name",
          subtitle: "A-Z",
          value: Constants.sortByAction.SORT_BY_NAMEATOZ,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEATOZ);
            setIsOpenSort(false);
          },
        },
        {
          title: "Name",
          subtitle: "Z-A",
          value: Constants.sortByAction.SORT_BY_NAMEZTOA,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEZTOA);
            setIsOpenSort(false);
          },
        },
      ]);
      setViewModeList([
        {
          title: "Grid",
          value: Constants.viewType.VIEW_TYPE_GRID,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_GRID);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "grid" },
            });
          },
        },
        {
          title: "List",
          value: Constants.viewType.VIEW_TYPE_LIST,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_LIST);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "list" },
            });
          },
        },
        // {
        //   title: "Overview",
        //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
        //   onClick: () => {
        //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
        //     setIsOpenViewMode(false);
        //     router.push({
        //       query: { ...router.query, page: 1, view: "overview" },
        //     });
        //   },
        // },
        {
          title: "Map",
          value: Constants.viewType.VIEW_TYPE_MAP,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_MAP);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "map" },
            });
          },
        },
      ]);
      setViewMode(Constants.viewType.VIEW_TYPE_GRID);
    } else if (category === "homes" || category === "animals") {
      setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([
        {
          title: "Recommended",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_RECOMMENDED,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
            setIsOpenSort(false);
          },
        },
        // {
        //   title: "Popularity",
        //   subtitle: null,
        //   value: Constants.sortByAction.SORT_BY_POPULARITY,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
        //     setIsOpenSort(false);
        //   },
        // },
        /*{
            title: "Trending",
            subtitle: null,
            value: Constants.sortByAction.SORT_BY_TRENDING,
            onClick: () => {
              setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
              setIsOpenSort(false);
            },
          },*/
        // {
        //   title: "Rating",
        //   subtitle: "Low-High",
        //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
        //     setIsOpenSort(false);
        //   },
        // },
        // {
        //   title: "Rating",
        //   subtitle: "High-Low",
        //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Name",
          subtitle: "A-Z",
          value: Constants.sortByAction.SORT_BY_NAMEATOZ,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEATOZ);
            setIsOpenSort(false);
          },
        },
        {
          title: "Name",
          subtitle: "Z-A",
          value: Constants.sortByAction.SORT_BY_NAMEZTOA,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEZTOA);
            setIsOpenSort(false);
          },
        },
      ]);
      setViewModeList([
        {
          title: "Grid",
          value: Constants.viewType.VIEW_TYPE_GRID,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_GRID);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "grid" },
            });
          },
        },
        {
          title: "List",
          value: Constants.viewType.VIEW_TYPE_LIST,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_LIST);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "list" },
            });
          },
        },
      ]);
      setViewMode(Constants.viewType.VIEW_TYPE_GRID);
    } else if (
      category === "rooftops" ||
      category === "spas" ||
      category === "beach-clubs" ||
      category === "companies" ||
      category === "zoos" ||
      category === "parks" ||
      category === "casinos" ||
      category === "castles" ||
      category === "resorts" ||
      category === "aparthotels" ||
      category === "bars"
    ) {
      setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([
        {
          title: "Recommended",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_RECOMMENDED,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
            setIsOpenSort(false);
          },
        },
        // {
        //   title: "Popularity",
        //   subtitle: null,
        //   value: Constants.sortByAction.SORT_BY_POPULARITY,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
        //     setIsOpenSort(false);
        //   },
        // },
        /*{
          title: "Trending",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_TRENDING,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
            setIsOpenSort(false);
          },
        },*/
        // {
        //   title: "Rating",
        //   subtitle: "Low-High",
        //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
        //     setIsOpenSort(false);
        //   },
        // },
        // {
        //   title: "Rating",
        //   subtitle: "High-Low",
        //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
        //   onClick: () => {
        //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
        //     setIsOpenSort(false);
        //   },
        // },
        {
          title: "Name",
          subtitle: "A-Z",
          value: Constants.sortByAction.SORT_BY_NAMEATOZ,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEATOZ);
            setIsOpenSort(false);
          },
        },
        {
          title: "Name",
          subtitle: "Z-A",
          value: Constants.sortByAction.SORT_BY_NAMEZTOA,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_NAMEZTOA);
            setIsOpenSort(false);
          },
        },
      ]);
      setViewModeList([
        {
          title: "Grid",
          value: Constants.viewType.VIEW_TYPE_GRID,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_GRID);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "grid" },
            });
          },
        },
        {
          title: "List",
          value: Constants.viewType.VIEW_TYPE_LIST,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_LIST);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "list" },
            });
          },
        },
        // {
        //   title: "Overview",
        //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
        //   onClick: () => {
        //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
        //     setIsOpenViewMode(false);
        //     router.push({
        //       query: { ...router.query, page: 1, view: "overview" },
        //     });
        //   },
        // },
        {
          title: "Map",
          value: Constants.viewType.VIEW_TYPE_MAP,
          onClick: () => {
            setViewMode(Constants.viewType.VIEW_TYPE_MAP);
            setIsOpenViewMode(false);
            router.push({
              query: { ...router.query, page: 1, view: "map" },
            });
          },
        },
      ]);
      setViewMode(Constants.viewType.VIEW_TYPE_GRID);
    }
  }, [category]);

  // Keyword search
  useEffect(() => {
    if (search) {
      setKeyword(search);
    }
  }, [search]);

  // View Mode
  useEffect(() => {
    // Get the button
    let mybutton = document.getElementById("btn-back-to-top");

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton?.classList?.add("flex");
        mybutton?.classList?.remove("hidden");
      } else {
        mybutton?.classList?.remove("flex");
        mybutton?.classList?.add("hidden");
      }
    }
  }, [viewMode]);
  useEffect(() => {
    if (view) {
      setViewMode(view);
    }
  }, [view]);

  const metaCategoryName = (category) => {
    let results = category?.toLowerCase();
    if (results === "bars") {
      results = "cocktail bars";
    } else if (results === "beach-clubs") {
      results = "beach clubs";
    } else if (results === "companies") {
      results = "prefab companies";
    } else if (results === "homes") {
      results = "prefab homes";
    } else if (results === "zoos") {
      results = "zoos & animal parks";
    } else if (results === "parks") {
      results = "amusement parks";
    } else if (results === "resorts") {
      results = "luxury resorts";
    }

    return results;
  };

  const metaTitle = `Discover ${metaCategoryName(category)} - ${
    process.env.NEXT_PUBLIC_APP_NAME
  }`;
  const metaDescription =
    category === "artists"
      ? `Discover artists on ${process.env.NEXT_PUBLIC_APP_NAME} - events, tickets and much more.`
      : category === "festivals"
      ? `Discover festivals on ${process.env.NEXT_PUBLIC_APP_NAME} - dates, venue, tickets, lineup and much more.`
      : category === "events"
      ? `Discover events on ${process.env.NEXT_PUBLIC_APP_NAME} - dates, venue, tickets, lineup and much more.`
      : `Discover ${metaCategoryName(category)} on ${
          process.env.NEXT_PUBLIC_APP_NAME
        } - ${
          process.env.NEXT_PUBLIC_APP_NAME === "Vybeful" ||
          process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
            ? "music, location"
            : category === "companies"
            ? "homes, features"
            : category === "homes"
            ? "price, features"
            : category === "animals"
            ? "habitat, features"
            : "location, features"
        } and much more.`;

  return (
    <div className={`${getClass("background", true)} relative`}>
      <NextSeo
        // TODO: check object keys router.query
        noindex={router?.query?.hasOwnProperty("page")}
        nofollow={false}
        title={metaTitle}
        description={metaDescription}
        canonical={`https://${
          process.env.NEXT_PUBLIC_WWW_BASE_URL
        }/explore/${category}${
          router?.query?.page ? `?page=${router?.query?.page}` : ""
        }`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${
            process.env.NEXT_PUBLIC_WWW_BASE_URL
          }/explore/${category}${
            router?.query?.page ? `?page=${router?.query?.page}` : ""
          }`,
          title: metaTitle,
          description: metaDescription,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />

      <div className="sm:block hidden">
        <HeaderSearch
          defaultValue={keyword}
          onPress={(result) => {
            setKeyword(result);
            router.push(
              `/explore/${process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(
                ","
              )[0]?.toLowerCase()}?search=${result}`
            );
          }}
        />
      </div>
      <h1 className="hidden">{metaTitle}</h1>
      <div className="mx-auto min-h-screen">
        {Values.deviceWidth < 640 ? (
          <div className="sm:hidden block wrapper-mobile mx-auto min-h-screen">
            <NavigationSearchView
              keyword={keyword}
              setKeyword={setKeyword}
              isMobileVersion={true}
              buttonPropsMenuMore={buttonPropsMenuMore}
            />
            {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
              (i) => i === "Festivals" || i === "Artists"
            ) ? (
              <div
                className={`${
                  isOpenMenuMore ? "visible" : ""
                } flex flex-col ${getClass(
                  "background",
                  true
                )} absolute top-[45px] right-4 rounded-2xl z-[999] w-190px border ${getClass(
                  "border-spliterLine",
                  true
                )} overflow-hidden`}
                role="menu">
                {/* <Link href="/charts/festivals">
                  <a
                    className={`px-4 py-3 text-xs font-regular ${getClass(
                      "text-white",
                      true
                    )} cursor-pointer transition-all ${getClass(
                      "hover:bg-grayBackground"
                    )} border-b ${getClass("border-spliterLine", true)}`}>
                    Charts
                  </a>
                </Link> */}
                {/* <Link href="/playlist">
                  <a
                    className={`px-4 py-3 text-xs font-regular ${getClass(
                      "text-white",
                      true
                    )} cursor-pointer transition-all ${getClass(
                      "hover:bg-grayBackground"
                    )} border-b ${getClass("border-spliterLine", true)}`}>
                    Playlist
                  </a>
                </Link> */}
                <Link href="/guides">
                  <a
                    className={`px-4 py-3 text-xs font-regular ${getClass(
                      "text-white",
                      true
                    )} cursor-pointer transition-all ${getClass(
                      "hover:bg-grayBackground"
                    )}`}>
                    Guides
                  </a>
                </Link>
              </div>
            ) : (
              <div
                className={`${
                  isOpenMenuMore ? "visible" : ""
                } flex flex-col ${getClass(
                  "background",
                  true
                )} absolute top-[45px] right-4 rounded-2xl z-[999] w-190px border ${getClass(
                  "border-spliterLine",
                  true
                )} overflow-hidden`}
                role="menu">
                <Link href="/guides">
                  <a
                    className={`px-4 py-3 text-xs font-regular ${getClass(
                      "text-white",
                      true
                    )} cursor-pointer transition-all ${getClass(
                      "hover:bg-grayBackground"
                    )}`}>
                    Guides
                  </a>
                </Link>
              </div>
            )}
            <FilterView
              dataCategory={dataCategory}
              isFiltered={
                dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
                  ? filterCriteriaListSelectedFestival !== null &&
                    filterCriteriaListSelectedFestival?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_EVENT
                  ? filterCriteriaListSelectedEvent !== null &&
                    filterCriteriaListSelectedEvent?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_ARTIST
                  ? filterCriteriaListSelectedArtist !== null &&
                    filterCriteriaListSelectedArtist?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_VENUE
                  ? filterCriteriaListSelectedVenue !== null &&
                    filterCriteriaListSelectedVenue?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
                  ? filterCriteriaListSelectedRooftop !== null &&
                    filterCriteriaListSelectedRooftop?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_SPA
                  ? filterCriteriaListSelectedSpa !== null &&
                    filterCriteriaListSelectedSpa?.length > 0
                  : dataCategory ===
                    Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                  ? filterCriteriaListSelectedVenueBeachful !== null &&
                    filterCriteriaListSelectedVenueBeachful?.length > 0
                  : dataCategory ===
                    Constants.categoryType.CATEGORY_PREFAB_COMPANY
                  ? filterCriteriaListSelectedPrefabCompany !== null &&
                    filterCriteriaListSelectedPrefabCompany?.length > 0
                  : dataCategory ===
                    Constants.categoryType.CATEGORY_PREFAB_HOMES
                  ? filterCriteriaListSelectedPrefabHome !== null &&
                    filterCriteriaListSelectedPrefabHome?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_ZOO
                  ? filterCriteriaListSelectedZoo !== null &&
                    filterCriteriaListSelectedZoo?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_ANIMAL
                  ? filterCriteriaListSelectedAnimal !== null &&
                    filterCriteriaListSelectedAnimal?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_PARKFUL
                  ? filterCriteriaListSelectedParkful !== null &&
                    filterCriteriaListSelectedParkful?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_CASINO
                  ? filterCriteriaListSelectedCasino !== null &&
                    filterCriteriaListSelectedCasino?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_CASTLE
                  ? filterCriteriaListSelectedCastle !== null &&
                    filterCriteriaListSelectedCastle?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_RESORT
                  ? filterCriteriaListSelectedResort !== null &&
                    filterCriteriaListSelectedResort?.length > 0
                  : dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL
                  ? filterCriteriaListSelectedAparthotel !== null &&
                    filterCriteriaListSelectedAparthotel?.length > 0
                  : dataCategory ===
                    Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                  ? filterCriteriaListSelectedVenueCocktail !== null &&
                    filterCriteriaListSelectedVenueCocktail?.length > 0
                  : filterCriteriaListSelectedOther !== null &&
                    filterCriteriaListSelectedOther?.length > 0
              }
              onPressLocation={() => {
                if (locationModal) {
                  locationModal.current.showModal();
                }
              }}
              onPressFilter={() => {
                setShowFilter(true);
              }}
              onPressSort={() => {
                if (sortMenuModal) {
                  sortMenuModal.current.showModal();
                }
              }}
              isMobileVersion={true}
            />
            <CTabSelector
              withoutMax={true}
              items={categoryMobile.filter((i) => i.isHide === false)}
              selectedIndex={categoryMobile
                .filter((i) => i.isHide === false)
                .findIndex((i) => i.id === dataCategory)}
              onSelectTab={(item, index) => {
                if (item.id === Constants.categoryType.CATEGORY_FESTIVAL) {
                  router.replace("/explore/festivals");
                  setDataCategory(Constants.categoryType.CATEGORY_FESTIVAL);
                } else if (item.id === Constants.categoryType.CATEGORY_EVENT) {
                  router.replace("/explore/events");
                  setDataCategory(Constants.categoryType.CATEGORY_EVENT);
                } else if (item.id === Constants.categoryType.CATEGORY_ARTIST) {
                  router.replace("/explore/artists");
                  setDataCategory(Constants.categoryType.CATEGORY_ARTIST);
                } else if (item.id === Constants.categoryType.CATEGORY_VENUE) {
                  router.replace("/explore/venues");
                  setDataCategory(Constants.categoryType.CATEGORY_VENUE);
                } else if (
                  item.id === Constants.categoryType.CATEGORY_ROOFTOP
                ) {
                  router.replace("/explore/rooftops");
                  setDataCategory(Constants.categoryType.CATEGORY_ROOFTOP);
                } else if (item.id === Constants.categoryType.CATEGORY_SPA) {
                  router.replace("/explore/spas");
                  setDataCategory(Constants.categoryType.CATEGORY_SPA);
                } else if (
                  item.id === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                ) {
                  router.replace("/explore/beach-clubs");
                  setDataCategory(
                    Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                  );
                } else if (
                  item.id === Constants.categoryType.CATEGORY_PREFAB_COMPANY
                ) {
                  router.replace("/explore/companies");
                  setDataCategory(
                    Constants.categoryType.CATEGORY_PREFAB_COMPANY
                  );
                } else if (
                  item.id === Constants.categoryType.CATEGORY_PREFAB_HOMES
                ) {
                  router.replace("/explore/homes");
                  setDataCategory(Constants.categoryType.CATEGORY_PREFAB_HOMES);
                } else if (item.id === Constants.categoryType.CATEGORY_ZOO) {
                  router.replace("/explore/zoos");
                  setDataCategory(Constants.categoryType.CATEGORY_ZOO);
                } else if (item.id === Constants.categoryType.CATEGORY_ANIMAL) {
                  router.replace("/explore/animals");
                  setDataCategory(Constants.categoryType.CATEGORY_ANIMAL);
                } else if (
                  item.id === Constants.categoryType.CATEGORY_PARKFUL
                ) {
                  router.replace("/explore/parks");
                  setDataCategory(Constants.categoryType.CATEGORY_PARKFUL);
                } else if (item.id === Constants.categoryType.CATEGORY_CASINO) {
                  router.replace("/explore/casinos");
                  setDataCategory(Constants.categoryType.CATEGORY_CASINO);
                } else if (item.id === Constants.categoryType.CATEGORY_CASTLE) {
                  router.replace("/explore/castles");
                  setDataCategory(Constants.categoryType.CATEGORY_CASTLE);
                } else if (item.id === Constants.categoryType.CATEGORY_RESORT) {
                  router.replace("/explore/resorts");
                  setDataCategory(Constants.categoryType.CATEGORY_RESORT);
                } else if (
                  item.id === Constants.categoryType.CATEGORY_APARTHOTEL
                ) {
                  router.replace("/explore/aparthotels");
                  setDataCategory(Constants.categoryType.CATEGORY_APARTHOTEL);
                } else if (
                  item.id === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                ) {
                  router.replace("/explore/bars");
                  setDataCategory(
                    Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                  );
                }
              }}
              containerStyle={{ marginTop: 16, paddingHorizontal: 16 }}
              isMobileVersion={true}
              showMax={true}
            />
            <ExploreSearch
              mapFocused={mapFocused}
              setMapFocused={setMapFocused}
              listFestival={itemsFestival}
              setListFestival={setItemsFestival}
              listEvent={itemsEvent}
              setListEvent={setItemsEvent}
              listVenue={itemsVenue}
              setListVenue={setItemsVenue}
              listRooftop={itemsRooftop}
              setListRooftop={setItemsRooftop}
              listSpa={itemsSpa}
              setListSpa={setItemsSpa}
              listVenueBeachful={itemsVenueBeachful}
              setListVenueBeachful={setItemsVenueBeachful}
              listPrefabCompany={itemsPrefabCompany}
              setListPrefabCompany={setItemsPrefabCompany}
              listPrefabHome={itemsPrefabHome}
              setListPrefabHome={setItemsPrefabHome}
              listZoo={itemsZoo}
              setListZoo={setItemsZoo}
              listAnimal={itemsAnimal}
              setListAnimal={setItemsAnimal}
              listParkful={itemsParkful}
              setListParkful={setItemsParkful}
              listCasino={itemsCasino}
              setListCasino={setItemsCasino}
              listCastle={itemsCastle}
              setListCastle={setItemsCastle}
              listResort={itemsResort}
              setListResort={setItemsResort}
              listAparthotel={itemsAparthotel}
              setListAparthotel={setItemsAparthotel}
              listVenueCocktail={itemsVenueCocktail}
              setListVenueCocktail={setItemsVenueCocktail}
              currentPageIndex={props.pageProps || page || 1}
              countFestival={countFestival}
              setCountFestival={setCountFestival}
              countEvent={countEvent}
              setCountEvent={setCountEvent}
              countArtist={countArtist}
              setCountArtist={setCountArtist}
              countVenue={countVenue}
              setCountVenue={setCountVenue}
              countRooftop={countRooftop}
              setCountRooftop={setCountRooftop}
              countSpa={countSpa}
              setCountSpa={setCountSpa}
              countVenueBeachful={countVenueBeachful}
              setCountVenueBeachful={setCountVenueBeachful}
              countPrefabCompany={countPrefabCompany}
              setCountPrefabCompany={setCountPrefabCompany}
              countPrefabHome={countPrefabHome}
              setCountPrefabHome={setCountPrefabHome}
              countZoo={countZoo}
              setCountZoo={setCountZoo}
              countAnimal={countAnimal}
              setCountAnimal={setCountAnimal}
              countParkful={countParkful}
              setCountParkful={setCountParkful}
              countCasino={countCasino}
              setCountCasino={setCountCasino}
              countCastle={countCastle}
              setCountCastle={setCountCastle}
              countResort={countResort}
              setCountResort={setCountResort}
              countAparthotel={countAparthotel}
              setCountAparthotel={setCountAparthotel}
              countVenueCocktail={countVenueCocktail}
              setCountVenueCocktail={setCountVenueCocktail}
              passViewMode={Constants.viewType.VIEW_TYPE_LIST}
              keyword={keyword}
              setKeyword={setKeyword}
              dataCategory={dataCategory}
              setDataCategory={setDataCategory}
              locationSelected={locationSelected}
              setLocationSelected={setLocationSelected}
              isMobileVersion={true}
              sortBy={getSortBy()}
              typeMode={typeMode}
              setSortBy={setSortBy}
              // Festival
              filterCriteriaListOriginalFestival={
                filterCriteriaListOriginalFestival
              }
              setFilterCriteriaListOriginalFestival={
                setFilterCriteriaListOriginalFestival
              }
              filterCriteriaListSelectedFestival={
                filterCriteriaListSelectedFestival
              }
              setFilterCriteriaListSelectedFestival={
                setFilterCriteriaListSelectedFestival
              }
              filterTabSelectedFestival={typeMode}
              setFilterTabSelectedFestival={setFilterTabSelectedFestival}
              // Artist
              filterCriteriaListOriginalArtist={
                filterCriteriaListOriginalArtist
              }
              setFilterCriteriaListOriginalArtist={
                setFilterCriteriaListOriginalArtist
              }
              filterCriteriaListSelectedArtist={
                filterCriteriaListSelectedArtist
              }
              setFilterCriteriaListSelectedArtist={
                setFilterCriteriaListSelectedArtist
              }
              filterTabSelectedArtist={typeMode}
              setFilterTabSelectedArtist={setFilterTabSelectedArtist}
              // Venue
              filterCriteriaListOriginalVenue={filterCriteriaListOriginalVenue}
              setFilterCriteriaListOriginalVenue={
                setFilterCriteriaListOriginalVenue
              }
              filterCriteriaListSelectedVenue={filterCriteriaListSelectedVenue}
              setFilterCriteriaListSelectedVenue={
                setFilterCriteriaListSelectedVenue
              }
              filterTabSelectedVenue={typeMode}
              setFilterTabSelectedVenue={setFilterTabSelectedVenue}
              // Rooftop
              filterCriteriaListOriginalRooftop={
                filterCriteriaListOriginalRooftop
              }
              setFilterCriteriaListOriginalRooftop={
                setFilterCriteriaListOriginalRooftop
              }
              filterCriteriaListSelectedRooftop={
                filterCriteriaListSelectedRooftop
              }
              setFilterCriteriaListSelectedRooftop={
                setFilterCriteriaListSelectedRooftop
              }
              filterTabSelectedRooftop={typeMode}
              setFilterTabSelectedRooftop={setFilterTabSelectedRooftop}
              // Spa
              filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
              setFilterCriteriaListOriginalSpa={
                setFilterCriteriaListOriginalSpa
              }
              filterCriteriaListSelectedSpa={filterCriteriaListSelectedSpa}
              setFilterCriteriaListSelectedSpa={
                setFilterCriteriaListSelectedSpa
              }
              filterTabSelectedSpa={typeMode}
              setFilterTabSelectedSpa={setFilterTabSelectedSpa}
              // Venue Beachful
              filterCriteriaListOriginalVenueBeachful={
                filterCriteriaListOriginalVenueBeachful
              }
              setFilterCriteriaListOriginalVenueBeachful={
                setFilterCriteriaListOriginalVenueBeachful
              }
              filterCriteriaListSelectedVenueBeachful={
                filterCriteriaListSelectedVenueBeachful
              }
              setFilterCriteriaListSelectedVenueBeachful={
                setFilterCriteriaListSelectedVenueBeachful
              }
              filterTabSelectedVenueBeachful={typeMode}
              setFilterTabSelectedVenueBeachful={
                setFilterTabSelectedVenueBeachful
              }
              // Prefab Company
              filterCriteriaListOriginalPrefabCompany={
                filterCriteriaListOriginalPrefabCompany
              }
              setFilterCriteriaListOriginalPrefabCompany={
                setFilterCriteriaListOriginalPrefabCompany
              }
              filterCriteriaListSelectedPrefabCompany={
                filterCriteriaListSelectedPrefabCompany
              }
              setFilterCriteriaListSelectedPrefabCompany={
                setFilterCriteriaListSelectedPrefabCompany
              }
              filterTabSelectedPrefabCompany={typeMode}
              setFilterTabSelectedPrefabCompany={
                setFilterTabSelectedPrefabCompany
              }
              // Prefab Home
              filterCriteriaListOriginalPrefabHome={
                filterCriteriaListOriginalPrefabHome
              }
              setFilterCriteriaListOriginalPrefabHome={
                setFilterCriteriaListOriginalPrefabHome
              }
              filterCriteriaListSelectedPrefabHome={
                filterCriteriaListSelectedPrefabHome
              }
              setFilterCriteriaListSelectedPrefabHome={
                setFilterCriteriaListSelectedPrefabHome
              }
              filterTabSelectedPrefabHome={typeMode}
              setFilterTabSelectedPrefabHome={setFilterTabSelectedPrefabHome}
              // Zoo
              filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
              setFilterCriteriaListOriginalZoo={
                setFilterCriteriaListOriginalZoo
              }
              filterCriteriaListSelectedZoo={filterCriteriaListSelectedZoo}
              setFilterCriteriaListSelectedZoo={
                setFilterCriteriaListSelectedZoo
              }
              filterTabSelectedZoo={typeMode}
              setFilterTabSelectedZoo={setFilterTabSelectedZoo}
              // Animal
              filterCriteriaListOriginalAnimal={
                filterCriteriaListOriginalAnimal
              }
              setFilterCriteriaListOriginalAnimal={
                setFilterCriteriaListOriginalAnimal
              }
              filterCriteriaListSelectedAnimal={
                filterCriteriaListSelectedAnimal
              }
              setFilterCriteriaListSelectedAnimal={
                setFilterCriteriaListSelectedAnimal
              }
              filterTabSelectedAnimal={typeMode}
              setFilterTabSelectedAnimal={setFilterTabSelectedAnimal}
              // Parkful
              filterCriteriaListOriginalParkful={
                filterCriteriaListOriginalParkful
              }
              setFilterCriteriaListOriginalParkful={
                setFilterCriteriaListOriginalParkful
              }
              filterCriteriaListSelectedParkful={
                filterCriteriaListSelectedParkful
              }
              setFilterCriteriaListSelectedParkful={
                setFilterCriteriaListSelectedParkful
              }
              filterTabSelectedParkful={typeMode}
              setFilterTabSelectedParkful={setFilterTabSelectedParkful}
              // Casino
              filterCriteriaListOriginalCasino={
                filterCriteriaListOriginalCasino
              }
              setFilterCriteriaListOriginalCasino={
                setFilterCriteriaListOriginalCasino
              }
              filterCriteriaListSelectedCasino={
                filterCriteriaListSelectedCasino
              }
              setFilterCriteriaListSelectedCasino={
                setFilterCriteriaListSelectedCasino
              }
              filterTabSelectedCasino={typeMode}
              setFilterTabSelectedCasino={setFilterTabSelectedCasino}
              // Castle
              filterCriteriaListOriginalCastle={
                filterCriteriaListOriginalCastle
              }
              setFilterCriteriaListOriginalCastle={
                setFilterCriteriaListOriginalCastle
              }
              filterCriteriaListSelectedCastle={
                filterCriteriaListSelectedCastle
              }
              setFilterCriteriaListSelectedCastle={
                setFilterCriteriaListSelectedCastle
              }
              filterTabSelectedCastle={typeMode}
              setFilterTabSelectedCastle={setFilterTabSelectedCastle}
              // Resort
              filterCriteriaListOriginalResort={
                filterCriteriaListOriginalResort
              }
              setFilterCriteriaListOriginalResort={
                setFilterCriteriaListOriginalResort
              }
              filterCriteriaListSelectedResort={
                filterCriteriaListSelectedResort
              }
              setFilterCriteriaListSelectedResort={
                setFilterCriteriaListSelectedResort
              }
              filterTabSelectedResort={typeMode}
              setFilterTabSelectedResort={setFilterTabSelectedResort}
              // Aparthotel
              filterCriteriaListOriginalAparthotel={
                filterCriteriaListOriginalAparthotel
              }
              setFilterCriteriaListOriginalAparthotel={
                setFilterCriteriaListOriginalAparthotel
              }
              filterCriteriaListSelectedAparthotel={
                filterCriteriaListSelectedAparthotel
              }
              setFilterCriteriaListSelectedAparthotel={
                setFilterCriteriaListSelectedAparthotel
              }
              filterTabSelectedAparthotel={typeMode}
              setFilterTabSelectedAparthotel={setFilterTabSelectedAparthotel}
              // Venue Cocktail
              filterCriteriaListOriginalVenueCocktail={
                filterCriteriaListOriginalVenueCocktail
              }
              setFilterCriteriaListOriginalVenueCocktail={
                setFilterCriteriaListOriginalVenueCocktail
              }
              filterCriteriaListSelectedVenueCocktail={
                filterCriteriaListSelectedVenueCocktail
              }
              setFilterCriteriaListSelectedVenueCocktail={
                setFilterCriteriaListSelectedVenueCocktail
              }
              filterTabSelectedVenueCocktail={typeMode}
              setFilterTabSelectedVenueCocktail={
                setFilterTabSelectedVenueCocktail
              }
            />
            {(dataCategory === Constants.categoryType.CATEGORY_FESTIVAL ||
              dataCategory === Constants.categoryType.CATEGORY_VENUE ||
              dataCategory === Constants.categoryType.CATEGORY_ROOFTOP ||
              dataCategory === Constants.categoryType.CATEGORY_SPA ||
              dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
              dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
              dataCategory === Constants.categoryType.CATEGORY_ZOO ||
              dataCategory === Constants.categoryType.CATEGORY_ANIMAL ||
              dataCategory === Constants.categoryType.CATEGORY_PARKFUL ||
              dataCategory === Constants.categoryType.CATEGORY_CASINO ||
              dataCategory === Constants.categoryType.CATEGORY_CASTLE ||
              dataCategory === Constants.categoryType.CATEGORY_RESORT ||
              dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL ||
              dataCategory ===
                Constants.categoryType.CATEGORY_VENUE_COCKTAIL) &&
              viewMode !== Constants.viewType.VIEW_TYPE_MAP && (
                <div className="fixed bottom-[100px] right-[16px]">
                  <div
                    className={`w-[60px] h-[60px] rounded-full ${getClass(
                      "bg-btn-map",
                      true
                    )} flex justify-center items-center cursor-pointer`}
                    onClick={() => {
                      setViewMode(Constants.viewType.VIEW_TYPE_MAP);
                      document.body.style.overflow = "hidden";
                    }}>
                    <CImage
                      source={Images.iconWorldwide}
                      width={32}
                      height={32}
                      layout="fixed"
                    />
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_FESTIVAL && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsFestival.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsFestival?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsFestival?.find((i) => i.id === mapFocused).id,
                            itemsFestival?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsFestival?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsFestival?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsFestival?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsFestival?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsFestival.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_VENUE && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsVenue.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsVenue?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsVenue?.find((i) => i.id === mapFocused).id,
                            itemsVenue?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsVenue?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsVenue?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsVenue?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsVenue?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsVenue.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_ROOFTOP && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsRooftop.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsRooftop?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsRooftop?.find((i) => i.id === mapFocused).id,
                            itemsRooftop?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsRooftop?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsRooftop?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsRooftop?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsRooftop?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsRooftop.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_SPA && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsSpa.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsSpa?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsSpa?.find((i) => i.id === mapFocused).id,
                            itemsSpa?.find((i) => i.id === mapFocused).title ||
                              itemsSpa?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsSpa?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsSpa?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsSpa?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsSpa.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory ===
                Constants.categoryType.CATEGORY_VENUE_BEACHFUL && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsVenueBeachful.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsVenueBeachful?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsVenueBeachful?.find((i) => i.id === mapFocused)
                              .id,
                            itemsVenueBeachful?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsVenueBeachful?.find(
                                (i) => i.id === mapFocused
                              ).displayName ||
                              itemsVenueBeachful?.find(
                                (i) => i.id === mapFocused
                              ).nickname,
                            itemsVenueBeachful?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsVenueBeachful?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsVenueBeachful.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory ===
                Constants.categoryType.CATEGORY_PREFAB_COMPANY && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsPrefabCompany.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsPrefabCompany?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsPrefabCompany?.find((i) => i.id === mapFocused)
                              .id,
                            itemsPrefabCompany?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsPrefabCompany?.find(
                                (i) => i.id === mapFocused
                              ).displayName ||
                              itemsPrefabCompany?.find(
                                (i) => i.id === mapFocused
                              ).nickname,
                            itemsPrefabCompany?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsPrefabCompany?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsPrefabCompany.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_ZOO && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsZoo.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsZoo?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsZoo?.find((i) => i.id === mapFocused).id,
                            itemsZoo?.find((i) => i.id === mapFocused).title ||
                              itemsZoo?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsZoo?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsZoo?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsZoo?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_PARKFUL && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsParkful.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsParkful?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsParkful?.find((i) => i.id === mapFocused).id,
                            itemsParkful?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsParkful?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsParkful?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsParkful?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsParkful?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_CASINO && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsCasino.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsCasino?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsCasino?.find((i) => i.id === mapFocused).id,
                            itemsCasino?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsCasino?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsCasino?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsCasino?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsCasino?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_CASTLE && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsCastle.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsCastle?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsCastle?.find((i) => i.id === mapFocused).id,
                            itemsCastle?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsCastle?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsCastle?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsCastle?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsCastle?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_RESORT && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsResort.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsResort?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsResort?.find((i) => i.id === mapFocused).id,
                            itemsResort?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsResort?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsResort?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsResort?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsResort?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsAparthotel.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsAparthotel?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsAparthotel?.find((i) => i.id === mapFocused)
                              .id,
                            itemsAparthotel?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsAparthotel?.find((i) => i.id === mapFocused)
                                .displayName ||
                              itemsAparthotel?.find((i) => i.id === mapFocused)
                                .nickname,
                            itemsAparthotel?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsAparthotel?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsZoo.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {viewMode === Constants.viewType.VIEW_TYPE_MAP &&
              dataCategory ===
                Constants.categoryType.CATEGORY_VENUE_COCKTAIL && (
                <div className="fixed left-0 top-0 h-full w-full">
                  <div className="absolute left-0 top-0 w-full h-full z-10">
                    <DynamicMap
                      borderRadius={0}
                      region={{
                        latitude: 51.495907,
                        longitude: -0.180144,
                        latitudeDelta: 0.0922,
                        longitudeDelta: 0.0421,
                      }}
                      items={itemsVenueCocktail.filter((i) => i.latitude)}
                      category={dataCategory}
                      selectedItem={mapFocused}
                      setSelectedItem={setMapFocused}
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 z-20 py-[30px]">
                    {itemsVenueCocktail?.find((i) => i.id === mapFocused) && (
                      <div {...handlers} className="flex flex-row">
                        <Link
                          prefetch={false}
                          href={generateURLSlug(
                            itemsVenueCocktail?.find((i) => i.id === mapFocused)
                              .id,
                            itemsVenueCocktail?.find((i) => i.id === mapFocused)
                              .title ||
                              itemsVenueCocktail?.find(
                                (i) => i.id === mapFocused
                              ).displayName ||
                              itemsVenueCocktail?.find(
                                (i) => i.id === mapFocused
                              ).nickname,
                            itemsVenueCocktail?.find((i) => i.id === mapFocused)
                              .startDate,
                            dataCategory,
                            "about"
                          )}>
                          <a className="pl-[8px]">
                            <div className="w-screen-custom rounded-lg overflow-hidden">
                              <CardItem
                                item={itemsVenueCocktail?.find(
                                  (i) => i.id === mapFocused
                                )}
                                category={dataCategory}
                                portrait={false}
                                fullWidth={false}
                                mapView={true}
                                isMobileVersion={true}
                                marginBottom={0}
                                // mapFocused={props.mapFocused}
                                // setMapFocused={props.setMapFocused}
                                // firstIndex={index === 0}
                                // lastIndex={index === itemsVenueCocktail.length - 1}
                                // onItemAction={onItemAction}
                              />
                            </div>
                          </a>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {(dataCategory === Constants.categoryType.CATEGORY_VENUE ||
              dataCategory === Constants.categoryType.CATEGORY_ROOFTOP ||
              dataCategory === Constants.categoryType.CATEGORY_SPA ||
              dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
              dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
              dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
              dataCategory === Constants.categoryType.CATEGORY_ZOO ||
              dataCategory === Constants.categoryType.CATEGORY_ANIMAL ||
              dataCategory === Constants.categoryType.CATEGORY_PARKFUL ||
              dataCategory === Constants.categoryType.CATEGORY_CASINO ||
              dataCategory === Constants.categoryType.CATEGORY_CASTLE ||
              dataCategory === Constants.categoryType.CATEGORY_RESORT ||
              dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL ||
              dataCategory ===
                Constants.categoryType.CATEGORY_VENUE_COCKTAIL) &&
              viewMode === Constants.viewType.VIEW_TYPE_MAP && (
                <div className="fixed bottom-[170px] right-[16px]">
                  <div
                    className={`w-[60px] h-[60px] rounded-full ${getClass(
                      "bg-btn-map",
                      true
                    )} flex justify-center items-center cursor-pointer`}
                    onClick={() => {
                      setViewMode(Constants.viewType.VIEW_TYPE_LIST);
                      document.body.style.overflow = "auto";
                    }}>
                    <CImage
                      source={Images.iconListColored}
                      width={32}
                      height={32}
                      layout="fixed"
                    />
                  </div>
                </div>
              )}
            {/* <div style={{ marginTop: 20 }}></div> */}
          </div>
        ) : (
          <div className="sm:block hidden wrapper mx-auto">
            <div
              className={`flex flex-row flex-1 items-center justify-between ${getClass(
                "background",
                true
              )}`}>
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Venues"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_VENUE?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/venues");
                    setDataCategory(Constants.categoryType.CATEGORY_VENUE);
                  }}>
                  VENUES
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Rooftops"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_ROOFTOP?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/rooftops");
                    setDataCategory(Constants.categoryType.CATEGORY_ROOFTOP);
                  }}>
                  ROOFTOPS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Spas"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_SPA?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/spas");
                    setDataCategory(Constants.categoryType.CATEGORY_SPA);
                  }}>
                  SPAS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Venue Beachful"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_VENUE_BEACHFUL?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/beach-clubs");
                    setDataCategory(
                      Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                    );
                  }}>
                  BEACH CLUBS
                </div>
              )} */}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Prefab Home"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_PREFAB_HOMES?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
                    router.push("/explore/homes");
                    setDataCategory(
                      Constants.categoryType.CATEGORY_PREFAB_HOMES
                    );
                  }}>
                  HOMES
                </div>
              )}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Prefab Company"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_PREFAB_COMPANY?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
                    router.push("/explore/companies");
                    setDataCategory(
                      Constants.categoryType.CATEGORY_PREFAB_COMPANY
                    );
                  }}>
                  COMPANIES
                </div>
              )}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Zoos"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_ZOO?.toString()
                      ? `text-white ${getClass("bg-gray1-active-category", true)} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/zoos");
                    setDataCategory(Constants.categoryType.CATEGORY_ZOO);
                  }}>
                  ZOOS
                </div>
              )} */}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Animals"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_ANIMAL?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_RECOMMENDED);
                    router.push("/explore/animals");
                    setDataCategory(Constants.categoryType.CATEGORY_ANIMAL);
                  }}>
                  ANIMALS
                </div>
              )}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Parks"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_PARKFUL?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/parks");
                    setDataCategory(Constants.categoryType.CATEGORY_PARKFUL);
                  }}>
                  PARKS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Casinos"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_CASINO?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/casinos");
                    setDataCategory(Constants.categoryType.CATEGORY_CASINO);
                  }}>
                  CASINOS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Castles"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_CASTLE?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/castles");
                    setDataCategory(Constants.categoryType.CATEGORY_CASTLE);
                  }}>
                  CASTLES
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Resorts"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_RESORT?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/resorts");
                    setDataCategory(Constants.categoryType.CATEGORY_RESORT);
                  }}>
                  RESORTS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Aparthotels"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_APARTHOTEL?.toString()
                      ? `text-white ${getClass(
                          "bg-gray1-active-category",
                          true
                        )} font-bold`
                      : "text-spliterLine font-bold"
                  } text-lg text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/aparthotels");
                    setDataCategory(Constants.categoryType.CATEGORY_APARTHOTEL);
                  }}>
                  APARTHOTELS
                </div>
              )} */}
              {/* {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Venue Cocktail"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_VENUE_COCKTAIL?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/bars");
                    setDataCategory(
                      Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                    );
                  }}>
                  BARS
                </div>
              )} */}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Festivals"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_FESTIVAL?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_RECENT);
                    router.push("/explore/festivals");
                    setDataCategory(Constants.categoryType.CATEGORY_FESTIVAL);
                  }}>
                  FESTIVALS
                </div>
              )}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Events"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_EVENT?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_RECENT);
                    router.push("/explore/events");
                    setDataCategory(Constants.categoryType.CATEGORY_EVENT);
                  }}>
                  EVENTS
                </div>
              )}
              {process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
                (i) => i === "Artists"
              ) && (
                <div
                  className={`${
                    dataCategory?.toString() ===
                    Constants.categoryType.CATEGORY_ARTIST?.toString()
                      ? "bg-grayBackground font-bold"
                      : "font-bold"
                  } text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer`}
                  onClick={() => {
                    setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
                    router.push("/explore/artists");
                    setDataCategory(Constants.categoryType.CATEGORY_ARTIST);
                  }}>
                  ARTISTS
                </div>
              )}
            </div>
            <div
              className={`flex flex-row ${getClass(
                "background",
                true
              )} pt-6 min-h-screen`}>
              <div className="pt-6 lg:w-335px w-230px">
                <div className="sticky top-0">
                  <FilterScreen
                    isMobileVersion={false}
                    setShowFilter={setShowFilter}
                    category={dataCategory}
                    setTabList={setTypeModeList}
                    tabList={typeModeList}
                    keyword={keyword}
                    locationDistance={locationSelected?.distance}
                    locationSelected={locationSelected}
                    setLocationSelected={setLocationSelected}
                    sortBy={
                      sortBy ||
                      (dataCategory ===
                        Constants.categoryType.CATEGORY_FESTIVAL ||
                      dataCategory === Constants.categoryType.CATEGORY_EVENT
                        ? Constants.sortByAction.SORT_BY_RECENT
                        : Constants.sortByAction.SORT_BY_POPULARITY)
                    }
                    filterTabSelected={typeMode}
                    filterCriteriaListOriginal={
                      dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
                        ? filterCriteriaListOriginalFestival
                        : dataCategory === Constants.categoryType.CATEGORY_EVENT
                        ? filterCriteriaListOriginalEvent
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ARTIST
                        ? filterCriteriaListOriginalArtist
                        : dataCategory === Constants.categoryType.CATEGORY_VENUE
                        ? filterCriteriaListOriginalVenue
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ROOFTOP
                        ? filterCriteriaListOriginalRooftop
                        : dataCategory === Constants.categoryType.CATEGORY_SPA
                        ? filterCriteriaListOriginalSpa
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                        ? filterCriteriaListOriginalVenueBeachful
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PREFAB_COMPANY
                        ? filterCriteriaListOriginalPrefabCompany
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PREFAB_HOMES
                        ? filterCriteriaListOriginalPrefabHome
                        : dataCategory === Constants.categoryType.CATEGORY_ZOO
                        ? filterCriteriaListOriginalZoo
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ANIMAL
                        ? filterCriteriaListOriginalAnimal
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PARKFUL
                        ? filterCriteriaListOriginalParkful
                        : Constants.categoryType.CATEGORY_CASINO
                        ? filterCriteriaListOriginalCasino
                        : Constants.categoryType.CATEGORY_CASTLE
                        ? filterCriteriaListOriginalCastle
                        : Constants.categoryType.CATEGORY_RESORT
                        ? filterCriteriaListOriginalResort
                        : Constants.categoryType.CATEGORY_APARTHOTEL
                        ? filterCriteriaListOriginalAparthotel
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                        ? filterCriteriaListOriginalVenueCocktail
                        : filterCriteriaListOriginalVenue
                    }
                    setFilterCriteriaListOriginal={(result) =>
                      dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
                        ? setFilterCriteriaListOriginalFestival(result)
                        : dataCategory === Constants.categoryType.CATEGORY_EVENT
                        ? setFilterCriteriaListOriginalEvent(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ARTIST
                        ? setFilterCriteriaListOriginalArtist(result)
                        : dataCategory === Constants.categoryType.CATEGORY_VENUE
                        ? setFilterCriteriaListOriginalVenue(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ROOFTOP
                        ? setFilterCriteriaListOriginalRooftop(result)
                        : dataCategory === Constants.categoryType.CATEGORY_SPA
                        ? setFilterCriteriaListOriginalSpa(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                        ? setFilterCriteriaListOriginalVenueBeachful(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PREFAB_COMPANY
                        ? setFilterCriteriaListOriginalPrefabCompany(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PREFAB_HOMES
                        ? setFilterCriteriaListOriginalPrefabHome(result)
                        : dataCategory === Constants.categoryType.CATEGORY_ZOO
                        ? setFilterCriteriaListOriginalZoo(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_ANIMAL
                        ? setFilterCriteriaListOriginalAnimal(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_PARKFUL
                        ? setFilterCriteriaListOriginalParkful(result)
                        : Constants.categoryType.CATEGORY_CASINO
                        ? setFilterCriteriaListOriginalCasino(result)
                        : Constants.categoryType.CATEGORY_CASTLE
                        ? setFilterCriteriaListOriginalCastle(result)
                        : Constants.categoryType.CATEGORY_RESORT
                        ? setFilterCriteriaListOriginalResort(result)
                        : Constants.categoryType.CATEGORY_APARTHOTEL
                        ? setFilterCriteriaListOriginalAparthotel(result)
                        : dataCategory ===
                          Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                        ? setFilterCriteriaListOriginalVenueCocktail(result)
                        : setFilterCriteriaListOriginalVenue(result)
                    }
                    onApply={(
                      filterSelected,
                      filterSelectedOriginal,
                      tabSelected
                    ) => {
                      router.replace({
                        query: { ...router.query, page: 1 },
                      });
                      if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_FESTIVAL
                      ) {
                        setFilterCriteriaListSelectedFestival(filterSelected);
                        setFilterCriteriaListOriginalFestival(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedFestival(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_EVENT
                      ) {
                        setFilterCriteriaListSelectedEvent(filterSelected);
                        setFilterCriteriaListOriginalEvent(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedEvent(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_ARTIST
                      ) {
                        setFilterCriteriaListSelectedArtist(filterSelected);
                        setFilterCriteriaListOriginalArtist(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedArtist(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_VENUE
                      ) {
                        setFilterCriteriaListSelectedVenue(filterSelected);
                        setFilterCriteriaListOriginalVenue(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedVenue(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
                      ) {
                        setFilterCriteriaListSelectedRooftop(filterSelected);
                        setFilterCriteriaListOriginalRooftop(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedRooftop(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_SPA
                      ) {
                        setFilterCriteriaListSelectedSpa(filterSelected);
                        setFilterCriteriaListOriginalSpa(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedSpa(tabSelected?.id);
                      } else if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                      ) {
                        setFilterCriteriaListSelectedVenueBeachful(
                          filterSelected
                        );
                        setFilterCriteriaListOriginalVenueBeachful(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedVenueBeachful(tabSelected?.id);
                      } else if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_PREFAB_COMPANY
                      ) {
                        setFilterCriteriaListSelectedPrefabCompany(
                          filterSelected
                        );
                        setFilterCriteriaListOriginalPrefabCompany(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedPrefabCompany(tabSelected?.id);
                      } else if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_PREFAB_HOMES
                      ) {
                        setFilterCriteriaListSelectedPrefabHome(filterSelected);
                        setFilterCriteriaListOriginalPrefabHome(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedPrefabHome(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_ZOO
                      ) {
                        setFilterCriteriaListSelectedZoo(filterSelected);
                        setFilterCriteriaListOriginalZoo(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedZoo(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_ANIMAL
                      ) {
                        setFilterCriteriaListSelectedAnimal(filterSelected);
                        setFilterCriteriaListOriginalAnimal(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedAnimal(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_PARKFUL
                      ) {
                        setFilterCriteriaListSelectedParkful(filterSelected);
                        setFilterCriteriaListOriginalParkful(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedParkful(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_CASINO
                      ) {
                        setFilterCriteriaListSelectedCasino(filterSelected);
                        setFilterCriteriaListOriginalCasino(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedCasino(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_CASTLE
                      ) {
                        setFilterCriteriaListSelectedCastle(filterSelected);
                        setFilterCriteriaListOriginalCastle(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedCastle(tabSelected?.id);
                      } else if (
                        dataCategory === Constants.categoryType.CATEGORY_RESORT
                      ) {
                        setFilterCriteriaListSelectedResort(filterSelected);
                        setFilterCriteriaListOriginalResort(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedResort(tabSelected?.id);
                      } else if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_APARTHOTEL
                      ) {
                        setFilterCriteriaListSelectedAparthotel(filterSelected);
                        setFilterCriteriaListOriginalAparthotel(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedAparthotel(tabSelected?.id);
                      } else if (
                        dataCategory ===
                        Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                      ) {
                        setFilterCriteriaListSelectedVenueCocktail(
                          filterSelected
                        );
                        setFilterCriteriaListOriginalVenueCocktail(
                          filterSelectedOriginal
                        );
                        setFilterTabSelectedVenueCocktail(tabSelected?.id);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="flex-1">
                <div
                  className={`flex flex-row flex-1 items-center justify-between ${getClass(
                    "background",
                    true
                  )} pb-2 pt-5 pl-8 ${
                    viewMode === Constants.viewType.VIEW_TYPE_OVERVIEW
                      ? "pr-8"
                      : ""
                  }`}>
                  <div className="relative">
                    <div
                      // {...buttonPropsTypeMode}
                      className={`${getClass(
                        "bg-gray1",
                        true
                      )} text-base text-white font-semibold text-center capitalize py-2 mr-4 w-160px rounded-full`}>
                      {typeModeList.find((item) => item.value === typeMode)
                        ? typeModeList.find((item) => item.value === typeMode)
                            ?.title
                        : "ALL"}{" "}
                      <span
                        className={`font-semibold ${getClass(
                          "text-gray2",
                          true
                        )}`}>
                        {dataCategory ===
                        Constants.categoryType.CATEGORY_FESTIVAL
                          ? nFormatter(countFestival)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_EVENT
                          ? nFormatter(countEvent)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_ARTIST
                          ? nFormatter(countArtist)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_ROOFTOP
                          ? nFormatter(countRooftop)
                          : dataCategory === Constants.categoryType.CATEGORY_SPA
                          ? nFormatter(countSpa)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                          ? nFormatter(countVenueBeachful)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_PREFAB_COMPANY
                          ? nFormatter(countPrefabCompany)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_PREFAB_HOMES
                          ? nFormatter(countPrefabHome)
                          : dataCategory === Constants.categoryType.CATEGORY_ZOO
                          ? nFormatter(countZoo)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_ANIMAL
                          ? nFormatter(countAnimal)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_PARKFUL
                          ? nFormatter(countParkful)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_CASINO
                          ? nFormatter(countCasino)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_CASTLE
                          ? nFormatter(countCastle)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_RESORT
                          ? nFormatter(countResort)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_APARTHOTEL
                          ? nFormatter(countAparthotel)
                          : dataCategory ===
                            Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                          ? nFormatter(countVenueCocktail)
                          : nFormatter(countVenue)}
                      </span>
                    </div>
                    <div
                      className={`${
                        isOpenTypeMode ? "visible" : ""
                      } flex flex-col ${getClass(
                        "background",
                        true
                      )} absolute top-[40px] left-0 rounded-2xl z-[999] w-160px border ${getClass(
                        "border-spliterLine",
                        true
                      )} py-4`}
                      role="menu">
                      {typeModeList.map((item, index) => (
                        <div
                          {...itemPropsTypeMode[index]}
                          key={index}
                          className={`text-base font-regular text-center ${getClass(
                            "text-white",
                            true
                          )} py-2 cursor-pointer transition-all ${getClass(
                            "hover:bg-gray1",
                            true
                          )} ${
                            item.value === typeMode
                              ? `${getClass("bg-gray1LightGray", true)}`
                              : ""
                          }`}
                          onClick={item.onClick}>
                          {item.title}{" "}
                          <span className="text-placeholder">
                            {item.count > 99 ? "99+" : item.count || 0}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="relative">
                      <div
                        {...buttonPropsViewMode}
                        className={`${getClass(
                          "bg-gray1",
                          true
                        )} text-base text-white font-semibold text-center capitalize py-2 mr-4 w-190px rounded-full cursor-pointer`}>
                        {viewModeList.find((item) => item.value === viewMode)
                          ?.title || "Grid"}
                      </div>
                      <div
                        className={`${
                          isOpenViewMode ? "visible" : ""
                        } flex flex-col ${getClass(
                          "background",
                          true
                        )} absolute top-[40px] left-0 rounded-2xl z-[999] w-190px border ${getClass(
                          "border-spliterLine",
                          true
                        )} py-4`}
                        role="menu">
                        {viewModeList.map((item, index) => (
                          <div
                            {...itemPropsViewMode[index]}
                            key={index}
                            className={`text-base font-regular text-center ${getClass(
                              "text-white",
                              true
                            )} py-2 cursor-pointer transition-all ${getClass(
                              "hover:bg-gray1",
                              true
                            )} ${
                              item.value === viewMode
                                ? `${getClass("bg-gray1LightGray", true)}`
                                : ""
                            }`}
                            onClick={item.onClick}>
                            {item.title}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="relative">
                      {viewMode === Constants.viewType.VIEW_TYPE_OVERVIEW ? (
                        <div
                          className={`${getClass(
                            "bg-gray1",
                            true
                          )} text-base text-white font-semibold text-center capitalize py-2 mr-0 w-190px rounded-full`}>
                          {sortList.find(
                            (item) =>
                              item.value ===
                              (sortBy ||
                                (dataCategory ===
                                  Constants.categoryType.CATEGORY_FESTIVAL ||
                                dataCategory ===
                                  Constants.categoryType.CATEGORY_EVENT
                                  ? Constants.sortByAction.SORT_BY_RECENT
                                  : Constants.sortByAction.SORT_BY_POPULARITY))
                          )
                            ? sortList.find(
                                (item) =>
                                  item.value ===
                                  (sortBy ||
                                    (dataCategory ===
                                      Constants.categoryType
                                        .CATEGORY_FESTIVAL ||
                                    dataCategory ===
                                      Constants.categoryType.CATEGORY_EVENT
                                      ? Constants.sortByAction.SORT_BY_RECENT
                                      : Constants.sortByAction
                                          .SORT_BY_POPULARITY))
                              )?.title
                            : "Popularity"}{" "}
                          {sortList.find(
                            (item) =>
                              item.value ===
                              (sortBy ||
                                (dataCategory ===
                                  Constants.categoryType.CATEGORY_FESTIVAL ||
                                dataCategory ===
                                  Constants.categoryType.CATEGORY_EVENT
                                  ? Constants.sortByAction.SORT_BY_RECENT
                                  : Constants.sortByAction.SORT_BY_POPULARITY))
                          )?.subtitle && (
                            <span className="text-placeholder">
                              {
                                sortList.find(
                                  (item) =>
                                    item.value ===
                                    (sortBy ||
                                      (dataCategory ===
                                        Constants.categoryType
                                          .CATEGORY_FESTIVAL ||
                                      dataCategory ===
                                        Constants.categoryType.CATEGORY_EVENT
                                        ? Constants.sortByAction.SORT_BY_RECENT
                                        : Constants.sortByAction
                                            .SORT_BY_POPULARITY))
                                )?.subtitle
                              }
                            </span>
                          )}
                        </div>
                      ) : (
                        <div
                          {...buttonPropsSort}
                          className={`${getClass(
                            "bg-gray1",
                            true
                          )} text-base text-white font-semibold text-center capitalize py-2 mr-0 w-190px rounded-full cursor-pointer`}>
                          {sortList.find(
                            (item) =>
                              item.value ===
                              (sortBy ||
                                (dataCategory ===
                                  Constants.categoryType.CATEGORY_FESTIVAL ||
                                dataCategory ===
                                  Constants.categoryType.CATEGORY_EVENT
                                  ? Constants.sortByAction.SORT_BY_RECENT
                                  : Constants.sortByAction.SORT_BY_POPULARITY))
                          )
                            ? sortList.find(
                                (item) =>
                                  item.value ===
                                  (sortBy ||
                                    (dataCategory ===
                                      Constants.categoryType
                                        .CATEGORY_FESTIVAL ||
                                    dataCategory ===
                                      Constants.categoryType.CATEGORY_EVENT
                                      ? Constants.sortByAction.SORT_BY_RECENT
                                      : Constants.sortByAction
                                          .SORT_BY_POPULARITY))
                              )?.title
                            : "Popularity"}{" "}
                          {sortList.find(
                            (item) =>
                              item.value ===
                              (sortBy ||
                                (dataCategory ===
                                  Constants.categoryType.CATEGORY_FESTIVAL ||
                                dataCategory ===
                                  Constants.categoryType.CATEGORY_EVENT
                                  ? Constants.sortByAction.SORT_BY_RECENT
                                  : Constants.sortByAction.SORT_BY_POPULARITY))
                          )?.subtitle && (
                            <span className="text-placeholder">
                              {
                                sortList.find(
                                  (item) =>
                                    item.value ===
                                    (sortBy ||
                                      (dataCategory ===
                                        Constants.categoryType
                                          .CATEGORY_FESTIVAL ||
                                      dataCategory ===
                                        Constants.categoryType.CATEGORY_EVENT
                                        ? Constants.sortByAction.SORT_BY_RECENT
                                        : Constants.sortByAction
                                            .SORT_BY_POPULARITY))
                                )?.subtitle
                              }
                            </span>
                          )}
                        </div>
                      )}
                      <div
                        className={`${
                          isOpenSort ? "visible" : ""
                        } flex flex-col ${getClass(
                          "background",
                          true
                        )} absolute top-[40px] left-0 rounded-2xl z-[999] w-190px border ${getClass(
                          "border-spliterLine",
                          true
                        )} py-4`}
                        role="menu">
                        {sortList.map((item, index) => (
                          <div
                            {...itemPropsSort[index]}
                            key={index}
                            className={`text-base font-regular text-center ${getClass(
                              "text-white",
                              true
                            )} py-2 cursor-pointer transition-all ${getClass(
                              "hover:bg-gray1"
                            )} ${
                              item.value ===
                              (sortBy ||
                                (dataCategory ===
                                  Constants.categoryType.CATEGORY_FESTIVAL ||
                                dataCategory ===
                                  Constants.categoryType.CATEGORY_EVENT
                                  ? Constants.sortByAction.SORT_BY_RECENT
                                  : Constants.sortByAction.SORT_BY_POPULARITY))
                                ? `${getClass("bg-gray1LightGray", true)}`
                                : ""
                            }`}
                            onClick={item.onClick}>
                            {item.title}{" "}
                            {item.subtitle && (
                              <span className="text-placeholder">
                                {item.subtitle}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row flex-1">
                  <div
                    className={`pl-8 ${
                      viewMode === Constants.viewType.VIEW_TYPE_MAP
                        ? ""
                        : "flex-1"
                    }`}
                    style={{ overflow: "hidden" }}>
                    <ExploreSearch
                      mapFocused={mapFocused}
                      setMapFocused={setMapFocused}
                      listFestival={itemsFestival}
                      setListFestival={setItemsFestival}
                      listEvent={itemsEvent}
                      setListEvent={setItemsEvent}
                      listVenue={itemsVenue}
                      setListVenue={setItemsVenue}
                      listRooftop={itemsRooftop}
                      setListRooftop={setItemsRooftop}
                      listSpa={itemsSpa}
                      setListSpa={setItemsSpa}
                      listVenueBeachful={itemsVenueBeachful}
                      setListVenueBeachful={setItemsVenueBeachful}
                      listPrefabCompany={itemsPrefabCompany}
                      setListPrefabCompany={setItemsPrefabCompany}
                      listPrefabHome={itemsPrefabHome}
                      setListPrefabHome={setItemsPrefabHome}
                      listZoo={itemsZoo}
                      setListZoo={setItemsZoo}
                      listAnimal={itemsAnimal}
                      setListAnimal={setItemsAnimal}
                      listParkful={itemsParkful}
                      setListParkful={setItemsParkful}
                      listCasino={itemsCasino}
                      setListCasino={setItemsCasino}
                      listCastle={itemsCastle}
                      setListCastle={setItemsCastle}
                      listResort={itemsResort}
                      setListResort={setItemsResort}
                      listAparthotel={itemsAparthotel}
                      setListAparthotel={setItemsAparthotel}
                      listVenueCocktail={itemsVenueCocktail}
                      setListVenueCocktail={setItemsVenueCocktail}
                      currentPageIndex={page || 1}
                      countFestival={countFestival}
                      setCountFestival={setCountFestival}
                      countEvent={countEvent}
                      setCountEvent={setCountEvent}
                      countArtist={countArtist}
                      setCountArtist={setCountArtist}
                      countVenue={countVenue}
                      setCountVenue={setCountVenue}
                      countRooftop={countRooftop}
                      setCountRooftop={setCountRooftop}
                      countSpa={countSpa}
                      setCountSpa={setCountSpa}
                      countVenueBeachful={countVenueBeachful}
                      setCountVenueBeachful={setCountVenueBeachful}
                      countPrefabCompany={countPrefabCompany}
                      setCountPrefabCompany={setCountPrefabCompany}
                      countPrefabHome={countPrefabHome}
                      setCountPrefabHome={setCountPrefabHome}
                      countZoo={countZoo}
                      setCountZoo={setCountZoo}
                      countAnimal={countAnimal}
                      setCountAnimal={setCountAnimal}
                      countParkful={countParkful}
                      setCountParkful={setCountParkful}
                      countCasino={countCasino}
                      setCountCasino={setCountCasino}
                      countCastle={countCastle}
                      setCountCastle={setCountCastle}
                      countResort={countResort}
                      setCountResort={setCountResort}
                      countAparthotel={countAparthotel}
                      setCountAparthotel={setCountAparthotel}
                      countVenueCocktail={countVenueCocktail}
                      setCountVenueCocktail={setCountVenueCocktail}
                      passViewMode={viewMode}
                      keyword={keyword}
                      setKeyword={setKeyword}
                      dataCategory={dataCategory}
                      setDataCategory={setDataCategory}
                      locationSelected={locationSelected}
                      setLocationSelected={setLocationSelected}
                      isMobileVersion={false}
                      sortBy={getSortBy()}
                      typeMode={typeMode}
                      setSortBy={setSortBy}
                      // Festival
                      filterCriteriaListOriginalFestival={
                        filterCriteriaListOriginalFestival
                      }
                      setFilterCriteriaListOriginalFestival={
                        setFilterCriteriaListOriginalFestival
                      }
                      filterCriteriaListSelectedFestival={
                        filterCriteriaListSelectedFestival
                      }
                      setFilterCriteriaListSelectedFestival={
                        setFilterCriteriaListSelectedFestival
                      }
                      filterTabSelectedFestival={typeMode}
                      setFilterTabSelectedFestival={
                        setFilterTabSelectedFestival
                      }
                      // Artist
                      filterCriteriaListOriginalArtist={
                        filterCriteriaListOriginalArtist
                      }
                      setFilterCriteriaListOriginalArtist={
                        setFilterCriteriaListOriginalArtist
                      }
                      filterCriteriaListSelectedArtist={
                        filterCriteriaListSelectedArtist
                      }
                      setFilterCriteriaListSelectedArtist={
                        setFilterCriteriaListSelectedArtist
                      }
                      filterTabSelectedArtist={typeMode}
                      setFilterTabSelectedArtist={setFilterTabSelectedArtist}
                      // Venue
                      filterCriteriaListOriginalVenue={
                        filterCriteriaListOriginalVenue
                      }
                      setFilterCriteriaListOriginalVenue={
                        setFilterCriteriaListOriginalVenue
                      }
                      filterCriteriaListSelectedVenue={
                        filterCriteriaListSelectedVenue
                      }
                      setFilterCriteriaListSelectedVenue={
                        setFilterCriteriaListSelectedVenue
                      }
                      filterTabSelectedVenue={typeMode}
                      setFilterTabSelectedVenue={setFilterTabSelectedVenue}
                      // Rooftop
                      filterCriteriaListOriginalRooftop={
                        filterCriteriaListOriginalRooftop
                      }
                      setFilterCriteriaListOriginalRooftop={
                        setFilterCriteriaListOriginalRooftop
                      }
                      filterCriteriaListSelectedRooftop={
                        filterCriteriaListSelectedRooftop
                      }
                      setFilterCriteriaListSelectedRooftop={
                        setFilterCriteriaListSelectedRooftop
                      }
                      filterTabSelectedRooftop={typeMode}
                      setFilterTabSelectedRooftop={setFilterTabSelectedRooftop}
                      // Spa
                      filterCriteriaListOriginalSpa={
                        filterCriteriaListOriginalSpa
                      }
                      setFilterCriteriaListOriginalSpa={
                        setFilterCriteriaListOriginalSpa
                      }
                      filterCriteriaListSelectedSpa={
                        filterCriteriaListSelectedSpa
                      }
                      setFilterCriteriaListSelectedSpa={
                        setFilterCriteriaListSelectedSpa
                      }
                      filterTabSelectedSpa={typeMode}
                      setFilterTabSelectedSpa={setFilterTabSelectedSpa}
                      // Venue Beachful
                      filterCriteriaListOriginalVenueBeachful={
                        filterCriteriaListOriginalVenueBeachful
                      }
                      setFilterCriteriaListOriginalVenueBeachful={
                        setFilterCriteriaListOriginalVenueBeachful
                      }
                      filterCriteriaListSelectedVenueBeachful={
                        filterCriteriaListSelectedVenueBeachful
                      }
                      setFilterCriteriaListSelectedVenueBeachful={
                        setFilterCriteriaListSelectedVenueBeachful
                      }
                      filterTabSelectedVenueBeachful={typeMode}
                      setFilterTabSelectedVenueBeachful={
                        setFilterTabSelectedVenueBeachful
                      }
                      // Prefab Company
                      filterCriteriaListOriginalPrefabCompany={
                        filterCriteriaListOriginalPrefabCompany
                      }
                      setFilterCriteriaListOriginalPrefabCompany={
                        setFilterCriteriaListOriginalPrefabCompany
                      }
                      filterCriteriaListSelectedPrefabCompany={
                        filterCriteriaListSelectedPrefabCompany
                      }
                      setFilterCriteriaListSelectedPrefabCompany={
                        setFilterCriteriaListSelectedPrefabCompany
                      }
                      filterTabSelectedPrefabCompany={typeMode}
                      setFilterTabSelectedPrefabCompany={
                        setFilterTabSelectedPrefabCompany
                      }
                      // Prefab Home
                      filterCriteriaListOriginalPrefabHome={
                        filterCriteriaListOriginalPrefabHome
                      }
                      setFilterCriteriaListOriginalPrefabHome={
                        setFilterCriteriaListOriginalPrefabHome
                      }
                      filterCriteriaListSelectedPrefabHome={
                        filterCriteriaListSelectedPrefabHome
                      }
                      setFilterCriteriaListSelectedPrefabHome={
                        setFilterCriteriaListSelectedPrefabHome
                      }
                      filterTabSelectedPrefabHome={typeMode}
                      setFilterTabSelectedPrefabHome={
                        setFilterTabSelectedPrefabHome
                      }
                      // Zoo
                      filterCriteriaListOriginalZoo={
                        filterCriteriaListOriginalZoo
                      }
                      setFilterCriteriaListOriginalZoo={
                        setFilterCriteriaListOriginalZoo
                      }
                      filterCriteriaListSelectedZoo={
                        filterCriteriaListSelectedZoo
                      }
                      setFilterCriteriaListSelectedZoo={
                        setFilterCriteriaListSelectedZoo
                      }
                      filterTabSelectedZoo={typeMode}
                      setFilterTabSelectedZoo={setFilterTabSelectedZoo}
                      // Animal
                      filterCriteriaListOriginalAnimal={
                        filterCriteriaListOriginalAnimal
                      }
                      setFilterCriteriaListOriginalAnimal={
                        setFilterCriteriaListOriginalAnimal
                      }
                      filterCriteriaListSelectedAnimal={
                        filterCriteriaListSelectedAnimal
                      }
                      setFilterCriteriaListSelectedAnimal={
                        setFilterCriteriaListSelectedAnimal
                      }
                      filterTabSelectedAnimal={typeMode}
                      setFilterTabSelectedAnimal={setFilterTabSelectedAnimal}
                      // Parkful
                      filterCriteriaListOriginalParkful={
                        filterCriteriaListOriginalParkful
                      }
                      setFilterCriteriaListOriginalParkful={
                        setFilterCriteriaListOriginalParkful
                      }
                      filterCriteriaListSelectedParkful={
                        filterCriteriaListSelectedParkful
                      }
                      setFilterCriteriaListSelectedParkful={
                        setFilterCriteriaListSelectedParkful
                      }
                      filterTabSelectedParkful={typeMode}
                      setFilterTabSelectedParkful={setFilterTabSelectedParkful}
                      // Casino
                      filterCriteriaListOriginalCasino={
                        filterCriteriaListOriginalCasino
                      }
                      setFilterCriteriaListOriginalCasino={
                        setFilterCriteriaListOriginalCasino
                      }
                      filterCriteriaListSelectedCasino={
                        filterCriteriaListSelectedCasino
                      }
                      setFilterCriteriaListSelectedCasino={
                        setFilterCriteriaListSelectedCasino
                      }
                      filterTabSelectedCasino={typeMode}
                      setFilterTabSelectedCasino={setFilterTabSelectedCasino}
                      // Castle
                      filterCriteriaListOriginalCastle={
                        filterCriteriaListOriginalCastle
                      }
                      setFilterCriteriaListOriginalCastle={
                        setFilterCriteriaListOriginalCastle
                      }
                      filterCriteriaListSelectedCastle={
                        filterCriteriaListSelectedCastle
                      }
                      setFilterCriteriaListSelectedCastle={
                        setFilterCriteriaListSelectedCastle
                      }
                      filterTabSelectedCastle={typeMode}
                      setFilterTabSelectedCastle={setFilterTabSelectedCastle}
                      // Resort
                      filterCriteriaListOriginalResort={
                        filterCriteriaListOriginalResort
                      }
                      setFilterCriteriaListOriginalResort={
                        setFilterCriteriaListOriginalResort
                      }
                      filterCriteriaListSelectedResort={
                        filterCriteriaListSelectedResort
                      }
                      setFilterCriteriaListSelectedResort={
                        setFilterCriteriaListSelectedResort
                      }
                      filterTabSelectedResort={typeMode}
                      setFilterTabSelectedResort={setFilterTabSelectedResort}
                      // Aparthotel
                      filterCriteriaListOriginalAparthotel={
                        filterCriteriaListOriginalAparthotel
                      }
                      setFilterCriteriaListOriginalAparthotel={
                        setFilterCriteriaListOriginalAparthotel
                      }
                      filterCriteriaListSelectedAparthotel={
                        filterCriteriaListSelectedAparthotel
                      }
                      setFilterCriteriaListSelectedAparthotel={
                        setFilterCriteriaListSelectedAparthotel
                      }
                      filterTabSelectedAparthotel={typeMode}
                      setFilterTabSelectedAparthotel={
                        setFilterTabSelectedAparthotel
                      }
                      // Venue Cocktail
                      filterCriteriaListOriginalVenueCocktail={
                        filterCriteriaListOriginalVenueCocktail
                      }
                      setFilterCriteriaListOriginalVenueCocktail={
                        setFilterCriteriaListOriginalVenueCocktail
                      }
                      filterCriteriaListSelectedVenueCocktail={
                        filterCriteriaListSelectedVenueCocktail
                      }
                      setFilterCriteriaListSelectedVenueCocktail={
                        setFilterCriteriaListSelectedVenueCocktail
                      }
                      filterTabSelectedVenueCocktail={typeMode}
                      setFilterTabSelectedVenueCocktail={
                        setFilterTabSelectedVenueCocktail
                      }
                    />
                    <div style={{ marginTop: 80 }} />
                  </div>
                  {viewMode === Constants.viewType.VIEW_TYPE_MAP && (
                    <div className="flex-1 pl-3">
                      <div className="sticky top-0 h-550px w-full py-4">
                        <DynamicMap
                          region={{
                            latitude: 51.495907,
                            longitude: -0.180144,
                            latitudeDelta: 0.0922,
                            longitudeDelta: 0.0421,
                          }}
                          items={
                            dataCategory ===
                            Constants.categoryType.CATEGORY_FESTIVAL
                              ? itemsFestival.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_EVENT
                              ? itemsEvent.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_ROOFTOP
                              ? itemsRooftop.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_SPA
                              ? itemsSpa.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                              ? itemsVenueBeachful.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_PREFAB_COMPANY
                              ? itemsPrefabCompany.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_PREFAB_HOMES
                              ? itemsPrefabHome.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_ZOO
                              ? itemsZoo.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_ANIMAL
                              ? itemsAnimal.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_PARKFUL
                              ? itemsParkful.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_CASINO
                              ? itemsCasino.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_CASTLE
                              ? itemsCastle.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_RESORT
                              ? itemsResort.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_APARTHOTEL
                              ? itemsAparthotel.filter((i) => i.latitude)
                              : dataCategory ===
                                Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                              ? itemsVenueCocktail.filter((i) => i.latitude)
                              : itemsVenue.filter((i) => i.latitude)
                          }
                          category={dataCategory}
                          selectedItem={mapFocused}
                          setSelectedItem={setMapFocused}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="sm:block hidden">
        <Footer />
      </div>
      <a
        id="btn-back-to-top"
        href="#"
        className={`${getClass(
          "bg-arrow-top",
          true
        )} hidden justify-center items-center w-12 h-12 fixed bottom-0 shadow right-0 z-10 mx-4 my-8 cursor-pointer rounded-full`}>
        <img
          src={`/icons/${
            process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
            process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld" ||
            process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
            process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
            process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia" ||
            process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club" ||
            process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub" ||
            process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub" ||
            process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl" ||
            process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" ||
            process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
              ? process.env.NEXT_PUBLIC_APP_NAME?.replace(
                  " ",
                  ""
                )?.toLowerCase() + "/"
              : ""
          }ic_arrow_top.png`}
          width="16"
          alt="icon back to top"
        />
      </a>

      <LocationModal
        ref={locationModal}
        category={dataCategory}
        locationSelected={locationSelected}
        distanceValue={locationSelected?.distance}
        isDistance
        isShowState={true}
        onPressApply={(location, distance) => {
          router.replace({
            query: { ...router.query, page: 1 },
          });
          setLocationSelected({ ...location, distance });
          if (locationModal) {
            locationModal.current.hideModal();
          }
        }}
        onPressCancel={() => {
          if (locationModal) {
            locationModal.current.hideModal();
          }
        }}
        isMobileVersion={true}
      />
      <SingleSelectModal
        ref={sortMenuModal}
        icon={Images.iconSortColored}
        title={t("key_sort")}
        checkedItemId={sortBy}
        items={sortMenu.filter((item) => item.isHide === false)}
        onPressItem={(item) => {
          setSortBy(item.id);
          if (sortMenuModal) {
            sortMenuModal.current.hideModal();
          }
        }}
        isMobileVersion={true}
      />

      {Values.deviceWidth < 640 && (
        <div
          className={`md:hidden ${
            showFilter ? "fixed" : "hidden"
          } w-full h-full top-0 left-0 z-999`}>
          <FilterScreen
            isMobileVersion={true}
            setShowFilter={setShowFilter}
            category={dataCategory}
            setTabList={setTypeModeList}
            tabList={typeModeList}
            keyword={keyword}
            locationDistance={locationSelected?.distance}
            locationSelected={locationSelected}
            setLocationSelected={setLocationSelected}
            sortBy={
              sortBy ||
              (dataCategory === Constants.categoryType.CATEGORY_FESTIVAL ||
              dataCategory === Constants.categoryType.CATEGORY_EVENT
                ? Constants.sortByAction.SORT_BY_RECENT
                : Constants.sortByAction.SORT_BY_POPULARITY)
            }
            filterTabSelected={typeMode}
            filterCriteriaListOriginal={
              dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
                ? filterCriteriaListOriginalFestival
                : dataCategory === Constants.categoryType.CATEGORY_EVENT
                ? filterCriteriaListOriginalEvent
                : dataCategory === Constants.categoryType.CATEGORY_ARTIST
                ? filterCriteriaListOriginalArtist
                : dataCategory === Constants.categoryType.CATEGORY_VENUE
                ? filterCriteriaListOriginalVenue
                : dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
                ? filterCriteriaListOriginalRooftop
                : dataCategory === Constants.categoryType.CATEGORY_SPA
                ? filterCriteriaListOriginalSpa
                : dataCategory ===
                  Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                ? filterCriteriaListOriginalVenueBeachful
                : dataCategory ===
                  Constants.categoryType.CATEGORY_PREFAB_COMPANY
                ? filterCriteriaListOriginalPrefabCompany
                : dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES
                ? filterCriteriaListOriginalPrefabHome
                : dataCategory === Constants.categoryType.CATEGORY_ZOO
                ? filterCriteriaListOriginalZoo
                : dataCategory === Constants.categoryType.CATEGORY_ANIMAL
                ? filterCriteriaListOriginalAnimal
                : dataCategory === Constants.categoryType.CATEGORY_PARKFUL
                ? filterCriteriaListOriginalParkful
                : dataCategory === Constants.categoryType.CATEGORY_CASINO
                ? filterCriteriaListOriginalCasino
                : dataCategory === Constants.categoryType.CATEGORY_CASTLE
                ? filterCriteriaListOriginalCastle
                : dataCategory === Constants.categoryType.CATEGORY_RESORT
                ? filterCriteriaListOriginalResort
                : dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL
                ? filterCriteriaListOriginalAparthotel
                : dataCategory ===
                  Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                ? filterCriteriaListOriginalVenueCocktail
                : filterCriteriaListOriginalVenue
            }
            setFilterCriteriaListOriginal={(result) =>
              dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
                ? setFilterCriteriaListOriginalFestival(result)
                : dataCategory === Constants.categoryType.CATEGORY_EVENT
                ? setFilterCriteriaListOriginalEvent(result)
                : dataCategory === Constants.categoryType.CATEGORY_ARTIST
                ? setFilterCriteriaListOriginalArtist(result)
                : dataCategory === Constants.categoryType.CATEGORY_VENUE
                ? setFilterCriteriaListOriginalVenue(result)
                : dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
                ? setFilterCriteriaListOriginalRooftop(result)
                : dataCategory === Constants.categoryType.CATEGORY_SPA
                ? setFilterCriteriaListOriginalSpa(result)
                : dataCategory ===
                  Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                ? setFilterCriteriaListOriginalVenueBeachful(result)
                : dataCategory ===
                  Constants.categoryType.CATEGORY_PREFAB_COMPANY
                ? setFilterCriteriaListOriginalPrefabCompany(result)
                : dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES
                ? setFilterCriteriaListOriginalPrefabHome(result)
                : dataCategory === Constants.categoryType.CATEGORY_ZOO
                ? setFilterCriteriaListOriginalZoo(result)
                : dataCategory === Constants.categoryType.CATEGORY_ANIMAL
                ? setFilterCriteriaListOriginalAnimal(result)
                : dataCategory === Constants.categoryType.CATEGORY_PARKFUL
                ? setFilterCriteriaListOriginalParkful(result)
                : dataCategory === Constants.categoryType.CATEGORY_PARKFUL
                ? setFilterCriteriaListOriginalParkful(result)
                : dataCategory ===
                  Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                ? setFilterCriteriaListOriginalVenueCocktail(result)
                : setFilterCriteriaListOriginalVenue(result)
            }
            onApply={(filterSelected, filterSelectedOriginal, tabSelected) => {
              router.replace({
                query: { ...router.query, page: 1 },
              });
              if (dataCategory === Constants.categoryType.CATEGORY_FESTIVAL) {
                setFilterCriteriaListSelectedFestival(filterSelected);
                setFilterCriteriaListOriginalFestival(filterSelectedOriginal);
                setFilterTabSelectedFestival(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_EVENT
              ) {
                setFilterCriteriaListSelectedEvent(filterSelected);
                setFilterCriteriaListOriginalEvent(filterSelectedOriginal);
                setFilterTabSelectedEvent(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_ARTIST
              ) {
                setFilterCriteriaListSelectedArtist(filterSelected);
                setFilterCriteriaListOriginalArtist(filterSelectedOriginal);
                setFilterTabSelectedArtist(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_VENUE
              ) {
                setFilterCriteriaListSelectedVenue(filterSelected);
                setFilterCriteriaListOriginalVenue(filterSelectedOriginal);
                setFilterTabSelectedVenue(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
              ) {
                setFilterCriteriaListSelectedRooftop(filterSelected);
                setFilterCriteriaListOriginalRooftop(filterSelectedOriginal);
                setFilterTabSelectedRooftop(tabSelected?.id);
              } else if (dataCategory === Constants.categoryType.CATEGORY_SPA) {
                setFilterCriteriaListSelectedSpa(filterSelected);
                setFilterCriteriaListOriginalSpa(filterSelectedOriginal);
                setFilterTabSelectedSpa(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
              ) {
                setFilterCriteriaListSelectedVenueBeachful(filterSelected);
                setFilterCriteriaListOriginalVenueBeachful(
                  filterSelectedOriginal
                );
                setFilterTabSelectedVenueBeachful(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY
              ) {
                setFilterCriteriaListSelectedPrefabCompany(filterSelected);
                setFilterCriteriaListOriginalPrefabCompany(
                  filterSelectedOriginal
                );
                setFilterTabSelectedPrefabCompany(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES
              ) {
                setFilterCriteriaListSelectedPrefabHome(filterSelected);
                setFilterCriteriaListOriginalPrefabHome(filterSelectedOriginal);
                setFilterTabSelectedPrefabHome(tabSelected?.id);
              } else if (dataCategory === Constants.categoryType.CATEGORY_ZOO) {
                setFilterCriteriaListSelectedZoo(filterSelected);
                setFilterCriteriaListOriginalZoo(filterSelectedOriginal);
                setFilterTabSelectedZoo(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_ANIMAL
              ) {
                setFilterCriteriaListSelectedAnimal(filterSelected);
                setFilterCriteriaListOriginalAnimal(filterSelectedOriginal);
                setFilterTabSelectedAnimal(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_PARKFUL
              ) {
                setFilterCriteriaListSelectedParkful(filterSelected);
                setFilterCriteriaListOriginalParkful(filterSelectedOriginal);
                setFilterTabSelectedParkful(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_CASINO
              ) {
                setFilterCriteriaListSelectedCasino(filterSelected);
                setFilterCriteriaListOriginalCasino(filterSelectedOriginal);
                setFilterTabSelectedCasino(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_CASTLE
              ) {
                setFilterCriteriaListSelectedCastle(filterSelected);
                setFilterCriteriaListOriginalCastle(filterSelectedOriginal);
                setFilterTabSelectedCastle(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_RESORT
              ) {
                setFilterCriteriaListSelectedResort(filterSelected);
                setFilterCriteriaListOriginalResort(filterSelectedOriginal);
                setFilterTabSelectedResort(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL
              ) {
                setFilterCriteriaListSelectedAparthotel(filterSelected);
                setFilterCriteriaListOriginalAparthotel(filterSelectedOriginal);
                setFilterTabSelectedAparthotel(tabSelected?.id);
              } else if (
                dataCategory === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
              ) {
                setFilterCriteriaListSelectedVenueCocktail(filterSelected);
                setFilterCriteriaListOriginalVenueCocktail(
                  filterSelectedOriginal
                );
                setFilterTabSelectedVenueCocktail(tabSelected?.id);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Festivals;
